'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
exports.PERSONAL =
    exports.PARENTS =
    exports.PERMISSIONS =
    exports.workshops =
    exports.register =
    exports.symbol =
    exports.vision =
    exports.activity =
    exports.educational =
    exports.contact =
    exports.footer =
    exports.signup =
    exports.about =
    exports.branches =
    exports.donate =
    exports.event =
    exports.thanks =
    exports.reports =
    exports.press =
    exports.mainpage =
    exports.navbar =
    exports.LANGUAGE =
        void 0;
const branch_parser_1 = require('./tools/branch_parser');
const cities_1 = require('./tools/cities');
const moment = require('moment');
let YEARS_ARR = [];
let num = 0;
let year = moment('1997-01-01').format('YYYY');
for (var i = 100; i >= 0; i--) {
    let elem = moment(year).add(num, 'years').format('YYYY');
    if (elem < moment().format('YYYY') + 1) {
        YEARS_ARR.push(elem);
        num++;
    }
}
let DAYS_ARR = [];
for (var i = 1; i <= 31; i++) {
    DAYS_ARR.push(i);
}
exports.LANGUAGE = 'arabic';
//////////Navbar/////////
exports.navbar = {
    NAVHOME: 'Home Page',
    NAV1: 'حَولنا',
    NAV2: 'فروع',
    NAV3: 'تقارير ',
    NAV4: 'من الإعلام',
    NAV5: 'مركز المعلومات',
    NAV6: 'القلب – بوّابة نشطاء',
    NAV7: 'اتصل بنا',
    NAV8: 'הרצאות וסדנאות',
    NAV_SIGN: 'تسجيل',
    NAV_DONATE: 'للتبرّع',
    educational_title: 'الرؤية التربويّة',
    educational_text: 'نخلق معًا متسعًا ومعنى لكل شخص',
    activity_title: 'نشاط الحركة',
    activity_text:
        'ميزة نشاطات الحركة ينبع من ملائمتها للأشخاص الذين يعانون من الإعاقات.',
    vision_title: 'رؤيا وقيَم الحركة',
    vision_text:
        'חיבור שיתוף בין צעירים עם מוגבלויות, לבין צעירים ללא מוגבלויות.',
    view_btn: 'צפה בעמוד',
    symbol_tite: 'حفلات ورموز',
    symbol_text: 'رمز رؤيانا',
    go_back: 'חזרה לעמוד הבית',
    navbar_h2: 'כנפיים של קרמבו',
    navbar_h4: 'תנועת נוער לצעירים עם ובלי צרכים מיוחדים',
    aboutSub1: 'הערכים שלנו',
    aboutSub2: 'كيف بدأ كل شيء',
    aboutSub3: 'مبنى الحركة',
    aboutSub4: 'ציוני דרך',
    aboutSub5: 'أعضاء الإدارة',
    aboutSub6: 'اللجنة الإدارية',
    aboutSub7: 'חזון התנועה',
    aboutSub8: 'كلمة المديرة العامة',
    pressSub1: 'مشاريع كرمبوية وتعاون',
    pressSub2: 'من الصحافة',
    pressSub3: 'مجلّة كرمبو',
    homeSub1: 'המפעלים שלנו',
    homeSub2: 'הערכים שלנו',
    homeSub22: 'رؤيا وقيَم الحركة',
    homeSub3: 'שותפינו ותומכינו',
    homeSub4: 'פרסים והוקרה',
};
//////////Main Page Text//////////
exports.mainpage = {
    ART_H3: 'תערוכת אומנות',
    ART_H2: 'של בנק הפועלים',
    ART_H2_2: 'למען כנפיים של קרמבו',
    ART_H2_2_DOT: '.',
    ART_H1: '21.12.19',
    CATALOG_BTN: 'לקטלוג לחצו כאן',
    //BANNER//
    BANNER_H1: 'יובל שר יוסי ',
    BANNER_H2: 'למען ילדי ‘כנפיים של קרמבו’',
    BANNER_P: '*מופע טרום הבכורה',
    BANNER_BTN: 'תקנון הגרלת "חלום כפול"',
    BANNER_ULAM: 'אולם סיטי הול',
    BANNER_MIKUM: 'סינמה סיטי גלילות',
    BANNER_STARTSHOW: 'תחילת המופע',
    BANNER_STARTSHOW_TIME: '21:00',
    BANNER_STARTSHOW_DATE: '26.5.2019',
    MAIN_S1_H2: 'المخيم الصيفي',
    MAIN_S1_H3: 'מחנה קיץ, המותאם גם לילדים ובני נוער עם צרכים מיוחדים',
    MAIN_S2_H2: 'הקמת סניפים',
    MAIN_S2_H3: 'סניף חדש שנפתח מביא שמחה ותחושת סיפוק לעשרות פעילים',
    MAIN_S3_H2: 'הכשרה והדרכה',
    MAIN_S3_H3: 'מערך ההכשרה וההדרכה שלנו, המכשיר את כלל בעלי התפקידים',
    MAIN_S4_H2: 'طلاب',
    MAIN_S4_H3: 'עלויות הקליטה לחניך בעל צרכים מיוחדים ומה הן כוללות',
    MAIN_S5_H2: 'מסע לפולין',
    MAIN_S5_H3: 'מסע משלחת הנוער המשותפת אל עבר אתרי הזיכרון בפולין',
    MAIN_S6_H2: 'שנת שירות',
    MAIN_S6_H3: 'קומונות השירות של "כנפיים של קרמבו" ועלותן המשוערת',
    MAIN_S1_READ: 'המשך קריאה',
    MAIN_DONATE_CHANGE: 'המחויבות שלנו',
    MAIN_DONATE_CHANGE_TEXT1: 'التزام بإتاحة كاملة',
    MAIN_DONATE_CHANGE_TEXT2: 'نوفّر مكانا ومعنى لكل شخص',
    MAIN_DONATE_CHANGE_TEXT3: 'طرح نشاط مجتمعي تربوي',
    MAIN_DONATE_CHANGE_TEXT4: 'إحداث تغيير مجتمعيّ',
    STORIES_H1: 'قصص بنكهة كرمبو',
    STORY1_TITLE: 'مقاطعة',
    STORY1_NAME: 'قصّة ليز بيشلا',
    STORY1_TEXT:
        'قصة ليز بيشلا حول كونها "كبش فداء" الصفّ، كيف واجهت تجربة المقاطعة وماذا تعلّمت من التجربة. تتحدث ليز عن شعور الانتماء الذي اكتسبته في "أجنحة كرمبو".',
    STORY2_TITLE: 'تحوُّل',
    STORY2_NAME: 'قصّة ميخال كوهن',
    STORY2_TEXT:
        'تتحدث ميخال كوهن عن تجربتها في فترة المراهقة والتحديات والصعوبات الكثيرة اتي واجهتها، وكيف أن انضمامها إلى حركة "أجنحة كرمبو" قد غيّر معتقداتها.',
    STORY3_TITLE: '“אהבה מבט ראשון”',
    STORY3_NAME: 'הסיפור של גדי דקל',
    STORY3_TEXT:
        'סיפורו המרתק של גדי דקל על דייטים הראשונים והמפתעים שנכח בהם. גדי מספר כיצד התאהב ברוח התנוע ובתוצר הסופי שלה - חיוכים ואושר אצל כל הצדדים המעורבים.',
    STORY4_TITLE: 'قديسون',
    STORY4_NAME: 'قصّة عنبال إيلسر',
    STORY4_TEXT:
        'تتحدث عنبال إيلسر عن حياتها في الكميونة المدمجة الأولى في إسرائيل، ولماذا شعرت بغرابة عندما أبلغها أمين الصندوق بأنها تقوم بـ"عمل مقدّس". ',
    STORY5_TITLE: 'آوتسايدر',
    STORY5_NAME: 'قصة إيميل أويفمان',
    STORY5_TEXT:
        'قصّة إيميل أويفمان تتحدث عن الوحدة التي عانى منها في طفولته، الشعور بعدم الانتماء، الجدران التي بناها والخيار الشجاع الذي اتخذه للتغلب على ذلك. ',
    STORY6_TITLE: 'תיק',
    STORY6_NAME: 'הסיפור של האחיות ליאה ורני קמחהסיפור של שלו גולדנברג ',
    STORY6_TEXT:
        'הסיפור של שלו גולדנברג על התמודדות עם התיק הרגשי הכבד שהכביד עליו במשך תקופה אורכה בחייו, ועל שותפיו למסע שבהם נעזר על מנת להקל על המעמסה.',
    STORY7_TITLE: ' האחיות',
    STORY7_NAME: 'הסיפור של האחיות ליאה ורני  ',
    STORY7_TEXT:
        'ליאה ורני קמחי מספרות על הקשר המיוחד השורר ביניהן והחוויות הראשונות שלהן מתנועת "כנפיים של קרמבו". לימים הפכה ליאה לרכזת בסניף "צור יגאל" ורני לחניכה משולהבת.',
    STORY8_TITLE: 'להיות שונה',
    STORY8_NAME: 'הסיפור של קסם בר',
    STORY8_TEXT:
        'הסיפור של קסם בר, על כיצד גילתה את השוני בחייה, כיצד חששה ממנו בילדותה ואיך לאחר שהצטרפה למשפחת כנפיים של קרמבו, גילתה שלהיות שונה זה בכלל לא בושה.',
    STORY_LINK: 'قناتنا على اليوتيوب',
    PARTNERS: 'شركاؤنا وداعمونا',
    DONATE: 'للتبرّع',
    FULL_LIST: 'לרשימה המלאה',
    AWARDS_H1: 'جوائز وتقدير',
    AWARD1: 'وسام تماري –(وسام رامون اليوم) – على الجودة، القيادة والتميّز',
    AWARD2: 'وسام برنشتاين – على اسم المرحومة سيلفيا برنشتاين – على التطوع والقيادةالمجتمعية',
    AWARD3: 'عزيزة مدينة هود هشارون "ليونزإسرائيل" – مقدمة لعدي التشولر مؤسسة الحركة',
    AWARD4: 'المبادرين العشرة للعام – "ارنست آنديانغ" بمشاركة "دي ماركر" – لعديالتشولر مؤسسة الحركة',
    AWARD5: 'إضاءة الشعلة في ذكرى الاستقلالالـ60 لدولة إسرائيل – باسم حركةالشبيبة وأبناء الشبيبة المتطوعين ',
    AWARD6: 'وسام الرئيس للمتطوع – على العملمن أجل إحداث التغيير المجتمعي للشبيبةالناشطين في "أجنحة كرمبو"',
    AWARD7: 'الحركة الاجتماعية في القرن – صحيفة "معاريف"',
    AWARD8: 'وسام ميدوت للنجاعة مقدّم للحركةعلى مدار عامين',
    AWARD9: 'جائزة وزارة المعارف لواء الجنوب لحاييم باوموول، عضو إدارة الحركة',
    AWARD10: 'جائزة يجآل ألون للأعمال الريادية المثالية',
    NEW_BRANCH_H1: 'הקמת סניפים',
    NEW_BRANCH_1_H2: 'כל סניף חדש שנפתח מביא שמחה לעשרות פעילים',
    NEW_BRANCH_1_P:
        'רבים מאתנו היו בתנועות נוער או חווים את הפעילות המיוחדת הזאת דרך הילדים הפרטיים שלנו, ויודעים עד כמה חשובים חיי חברה להתפתחות תקינה של ילדים.´כנפיים של קרמבו´ הינה תנועת נוער לילדים ונוער עם צרכים מיוחדים, המשלבת אותם בפעילות חברתית-חינוכית עם בני נוער מהחינוך הכללי',
    NEW_BRANCH_1_P_2:
        'ילדים עם צרכים מיוחדים מורכבים, מתקשים לפתח חיי חברה בגלל אתגרים כגון מגבלות תקשורת, צורך במקום נגיש עבורם והיותם ´שונים´.אתגרים אלו מקשים עליהם ולפעמים מונעים מהם להיפגש עם בני גילם, עם ובלי צרכים מיוחדים, ולהצטרף לתנועות הנוער הפועלות בישראל.',
    NEW_BRANCH_2_H2: ' קצת על מה שקורה בפעילות הסניפים',
    NEW_BRANCH_2_P:
        ' הפעילות בסניפים מתקיימת מידי שבוע, בשעות אחר הצהריים, במשך כשלוש שעות, במודל של חונכות אישית-במסגרת קבוצתית. לכל חניך מוצמדים שני חונכים המתווכים עבורו את הפעילויות, לומדים להכירו ומלווים אותו לאורך כל השנה.',
    NEW_BRANCH_2_P_2:
        ' החניכים והחונכים עושים יחדיו למען הקהילה: מתנדבים יחדיו, פעילים במוסדות הדמוקרטים של התנועה, עוברים פעולות ואפילו נופשים יחד במחנה קיץ.',
    NEW_BRANCH_3_H2: ' קצת על מה שקורה בפעילות הסניפים',
    NEW_BRANCH_3_P:
        ' התנועה רואה בפתיחת סניפים חדשים ביישובי הארץ, ציווי מוסרי ופועלת להקמת סניף בכל עיר בישראל. בסניף פעילים עד 40 ילדים בעלי צרכים מיוחדים וכ-100 בני נוער החונכים אותם.',
    NEW_BRANCH_3_P_2:
        ' הסניפים אשר נפתחים בפריפריה הפיזית והחברתית בישראל, הם פרי שיתוף פעולה של התנועה עם הרשויות המקומיות, אשר מקצות את המקום הנגיש לפעילות ומסייעות במימון הסעת החניכים בעלי הצרכים המיוחדים, מביתם לסניף ובחזרה.',
    NEW_BRANCH_3_P_3:
        ' התנועה פועלת לגיוס שותפים מהארץ ומחו"ל לשם הקמת סניפי תנועה חדשים.אנו מאמינים באיגום כוחות של קהילת העסקים המקומית והארצית, של קרנות פילנטרופיות ושל תורמים פרטיים – למען הקמת הסניפים.',
    NEW_BRANCH_STICKER:
        'תנועת ´כנפיים של קרמבו´ נתפחה במיוחד עבור ילדים בעלי צרכים מיוחדים. היא מותאמת לצרכיהם ונגישה עבורם. ',
    krembo_wings: ' "أجنحة كرمبو"',
    our_sections: 'המפעלים שלנו',
    SUMMER_CAMP_H1: 'מחנה קיץ ',
    SUMMER_CAMP_H2:
        'מחנה קיץ חוויתי, המותאם גם לילדים ובני נוער עם צרכים מיוחדים',
    SUMMER_CAMP_H3:
        "כמו כל תנועות הנוער, גם תנועת 'כנפיים של קרמבו' מקיימת מחנה קיץ חווייתי לחניכיה. המחנה מותאם לכל החניכים, גם לחניכים עם צרכים מיוחדים.",
    SUMMER_CAMP1_H3: 'מחנה קיץ שהוא גם חופשה משפחתית',
    SUMMER_CAMP1_P:
        'במחנה הקיץ נהנים ומשתתפים, גם בני המשפחות של חניכים עם צרכים מיוחדים אנו רואים חשיבות רבה בשילוב בני המשפחות במחנה הקיץ, מתוך אמונה כי למשפחה תפקיד חשוב בהעצמת ילדים החיים עם צרכים מיוחדים מורכבים.',
    SUMMER_CAMP1_P2:
        'בנוסף, הורים לילדים עם צרכים מיוחדים מתמודדים מדי יום עם טיפול אינטנסיבי בצרכיו של ילדם ומתקשים לעמוד בהוצאות חופשה משפחתית שהופכת למורכבת יותר, הן מבחינה ארגונית והן מבחינה כלכלית. מחנה הקיץ של כנפיים של קרמבו מעניק למשפחות גיבוש משפחתי, מנוחה וחוויה משותפת.',
    SUMMER_CAMP2_H3: 'מתי מתקיים מחנה הקיץ ומה קורה בו',
    SUMMER_CAMP2_P:
        'המחנה מתקיים מידי שנה בחודש אוגוסט, בבית קיי בנהריה - אתר הנופש היחיד בישראל שבו כמות חדרים רבה הנגישה לכיסאות גלגלים. לאור הדרישה הרבה של המשפחות, מחנה הקיץ מתקיים בשלושה מחזורים.',
    SUMMER_CAMP2_P2:
        'הפעילויות במחנה מותאמות לכל המשתתפים באופן מודולרי, המשלב אותם יחד ולחוד בפעילויות נופש חווייתיות ומאתגרות: פעילות בבריכה, פעולות יצירה, ספורט, יוגה, תחרויות, הצגות, מופעים, קוסמים, קבוצות תמיכה למשתתפים ופעולות שמטרתן גיבוש חווייתי, הן של החניכים עם חונכיהם והן שלהם עם בני משפחתם. החונכים, אשר מבלים זמן ארוך ואיכותי עם חניכיהם, זוכים להכירם בצורה עמוקה יותר, מכירים את בני המשפחה הסובבים אותם ומאפשרים להורים זמן איכות לעצמם ולילדיהם האחרים.',
    SUMMER_CAMP_BTN: 'איך מצטרפים',
    SUMMER_CAMP_LEFT:
        '“מעולם לא חווינו נופש משפחתי משותף. הייתה זו החוויה הכי מגבשת ומהנה לה זכינו מאז נולד הבן המיוחד שלנו, לפני 15 שנים!”',
    TRAINIGN_H1: 'הכשרה והדרכה',
    TRAINIGN_H2: 'הכשרת חונכים וצוותים',
    TRAINING_P_1:
        '´כנפיים של קרמבו´ היא תנועת הנוער הראשונה והיחידה לילדים ובני נוער בעלי צרכים מיוחדים מורכבים. התנועה משלבת חניכים עם צרכים מיוחדים בפעילות חינוכית חברתית, יחד עם בני נוער מהחינוך הכללי ונוער בסיכון בגילאי 18-14, המשמשים חונכים ומתווכי פעילות עבורם.',
    TRAINING_P_2:
        'החניכים בעלי הצרכים המיוחדים הינם ילדים ונוער, בגילאי 21-7.ילדים אלו אינם מתקבלים לתנועות הנוער האחרות, מפאת נכותם הקשה ולרבים מהם הבדידות אף קשה יותר מהנכות.',
    TRAINING_P_3:
        ' לרבים מהחניכים בעלי הצרכים המיוחדים, זוהי הפעילות החברתית היחידה לה הם זוכים מחוץ למסגרת בית הספר וההזדמנות היחידה לקשרים חברתיים עם ילדים ובני נוער החיים ללא מגבלות.',
    TRAINING_H3:
        'עבור מרבית החונכים, זהו המפגש הראשון עם בני גילם, החיים עם צרכים מיוחדים.',
    TRAINING_P_4:
        'לשם הכשרתם וכדי להבטיח את תפקודם המיטבי עבור חניכים בעלי צרכים מיוחדים,נדרש מערך הדרכה נרחב ועמוק.',
    TRAINING_P_5:
        ' מערך ההכשרה והדרכה של התנועה מיועד לכל בעלי התפקידים חונכים, צוות מוביל, רכזים ובוגרים המלווים את הסניפים ורכזי צרכים מיוחדים. ',
    TRAINING_P_6:
        'פיתוח ההכשרה וההדרכה בתנועה משפר את התושייה התפקודית, רמת הביצוע, המקצועיות ותחושת המחויבות לתנועה מצד החונכים ובעלי התפקידים בסניפים.',
    TRAINING_JOIN: 'איך מצטרפים',
    TRAINING_MILESTONES_H2: 'יעדי ההכשרה',
    TRAINING_MILESTONES_P_1:
        'מתן כלים מקצועיים לחונכים, לשם התמודדות עם ילדים בעלי צרכים מיוחדים ולתקשורת מיטבית עימם (כולל שפת הסימנים).',
    TRAINING_MILESTONES_P_2:
        'שיפור היכולות והמיומנויות של החונכים ובעלי התפקידים בסניפים בתחומים כגון הדרכה, כישורים חברתיים ותקשורתיים, עבודת צוות.',
    TRAINING_MILESTONES_P_3:
        'יצירת שיח חונכים ארצי, מפרה ומצמיח וגיבוש תנועתי.',
    TRAINING_MILESTONES_P_4:
        'מתן כלים מקצועיים לניהול הסניפים, התנהלות לוגיסטית ולהנעת מתנדבים',
    TRAINING_MILESTONES_P_5:
        'פיתוח מנהיגות צעירה של בני נוער כמובילי שינוי בסביבתם החברתית ובקהילה.    ',
    TRAINING_MILESTONES_P_6:
        'יצירת מערך פעילויות של הסניפים בקהילה, שמטרתו הובלת שינוי חברתי.',
    TRAINING_MILESTONES_2_H2: 'קורסים וסמינרים',
    TRAINING_MILESTONES2_P1: 'הכשרת חונכים בסניפים.',
    TRAINING_MILESTONES2_P2:
        'סמינר פתיחת שנה, אמצע וסוף שנה (מחוזי/ארצי) - לחונכים ולבעלי תפקידים.',
    TRAINING_MILESTONES2_P3:
        'סמינר מודולרי (מחוזי/ארצי) לבעלי תפקידים: צוותים מובילים, רכזים בוגרים ורכזי צרכים מיוחדים.',
    TRAINING_MILESTONES2_P4: 'סמינר הדרכה (מחוזי/ארצי) לצוותי ההדרכה.',
    TRAINING_MILESTONES2_P5: 'הכשרה חודשית (ארצי) לרכזי צרכים מיוחדים.',
    TRAINING_MILESTONES2_P6: 'יום חונכים תנועתי ארצי.',
    POLAND_H1: 'מסע לפולין',
    POLAND_H2: 'מסע משלחת נוער מיוחדת לאתרי הזיכרון בפולין',
    POLAND_P1:
        "בשנת 2013, בני הנוער הפעילים ב'כנפיים של קרמבו' יזמו את הקמתה של משלחת נוער משותפת של חניכים וחונכים, למסע לאתרי הזיכרון בפולין. היוזמה הגיעה מתוך תחושה שלכולם מגיע האפשרות והזכות לייצג את מדינת ישראל במדי התנועה.",
    POLAND_P2:
        'כתנועה, אנו מאמינים כי המסע לפולין הוא מסע עוצמתי של אדם לשורשיו ולעצמו ובזכות חיבוקה של הקבוצה הוא אף עוצמתי יותר. למסע המיוחד שלנו משמעות חברתית נרחבת, בחיבור בין אוכלוסיות ויצירת קהילה תומכת ומגובשת.',
    POLAND_P3:
        'משלחת הנוער שלנו מונה 90 אנשים וכוללת: בני נוער עם ובלי צרכים מיוחדים, הורים מלווים של החניכים ו-10 אנשי צוות מטה התנועה ומדריכים. ההכנה למסעה של המשלחת המיוחדת היא עמוקה וכוללת את כל התכנים ההיסטוריים ומשמעותם העמוקה וכן הכנה רגשית המותאמת לחניכים והחונכים כאחד.',
    POLAND_H3: 'כל חברי המשלחת, כולל הורי החניכים, שותפים בכל מרכיבי ההכנה',
    POLAND_P4:
        'סדנאות, מפגשים, הצגה וביקורים ב׳יד ושם׳ / קיבוץ לוחמי הגטאות. חלק מהחונכים והחניכים היוצאים למסע, הם בני משפחות קשות יום אשר מצבן הכלכלי אינו מאפשר מימון חלקם בעלות הנסיעה ואנו מגייסים מימון עבורם.',
    SERVICE_H1: 'שנת שירות',
    SERVICE_H2: 'קומונת שנת שירות',
    SERVICE_P:
        'משנת 2016 אנו פועלים ב-5 קומונות: בנוף הגליל, יפו, הוד השרון, קרית גת ובאר שבע. בכל קומונה פועלים 10-8 בני נוער בשנת שרות. תכנית הפעילות של הקומונות נבנית יחד עם הרשות המקומית במרחבן הן פועלות.',
    SERVICE_P2:
        'בשעות הבוקר, פעילי שנת השירות עוסקים בתחומי שילוב ילדים עם צרכים מיוחדים בבתי הספר במסגרת החינוך הפורמלי ובשעות אחר הצהריים עוסקים בפעילויות חברתיות במסגרת החינוך הבלתי פורמלי, עם נוער בסיכון ונוער מנותק. בנוסף, פעילי שנת השירות מעניקים סיוע, תמיכה והדרכה לסניפים במחוז בו הם פועלים.    ',
    SERVICE_H3:
        'עלות משוערת לתפעול הקומונה עומדת על כ-150,000 ש"ח לשנת פעילות.',
    PARTICIPANTS_H1: 'חניכים',
    PARTICIPANTS_H2: 'עלות קליטת חניך בעל צרכים מיוחדים',
    PARTICIPANTS_P:
        'על מנת לקלוט חניך עם צרכים מיוחדים לפעילות, אנו נדרשים למערך תמיכה נרחב. עלות קליטת חניך בעל צרכים מיוחדים לפעילות שוטפת בתנועה, ',
    PARTICIPANTS_H3: 'מסתכמת בכ-4,500 ₪ לשנה.',
    PARTICIPANTS_P2_SMALL: 'העלות כוללת את כל מרכיבי הפעילות השוטפת בסניפים',
    PARTICIPANTS_P2:
        'אמצעי התקשורת הייחודיים הנדרשים עבור שילוב מיטבי של חניכים בפעילות, יצירת פעולות נגישות, חומרי יצירה, מפעלים תנועתיים (כמו מחנה קיץ), טיולים סניפיים, סדנאות, מופעים, ציון חגים וימי הולדת, ועוד.',
    PARTICIPANTS_H2_2: 'ביטוחים',
    PARTICIPANTS_P3:
        'העלות המשוערת של ביטוח כלל פעילי התנועה בסניפים מגיעה לסכום של כ-30 ש"ח בשנה לכל פעיל. העלות המשוערת ל5,000 פעילי התנועה הקיימים היא כ- 150,000 שקלים',
    PARTICIPANTS_H2_3: 'מדי התנועה',
    PARTICIPANTS_P4:
        'כל פעילי התנועה לובשים את אותם המדים, כסימן לשוויון ואחדות מדי התנועה הם חולצה בצבע תכלת עם סמל התנועה ועניבה חומה. החולצה עוצבה כך שתהיה נגישה לילדים עם מוגבלויות פיזיות והיא קלה ללבישה. החולצה והעניבה נרכשות בתחילת שנת הפעילות ע "י כל פעיל במחיר של 50₪ . עלות ל-5,000 פעילי התנועה היא 250,000₪',
    PARTICIPANTS_H2_4: 'הסעות',
    PARTICIPANTS_P5:
        'התנועה מנגישה את פעולותיה גם באמצעות הפעלת מערך הסעות נגישות. אנו מסיעים את החניכים מבית הוריהם לפעילות הסניף ובחזרה. עלות ההסעה השנתית תלויה במיקום הסניף (סניף מקומי או אזורי) ונעה בין 35,000 ₪ לסניף מקומי ועד 100,000 ₪ לסניף אזורי עלות משוערת: בין 35,000 ₪ ל-100,000',
    PARTICIPANTS_btn: 'הרשמת חניך',
    special: 'בהוקרה מיוחדת',
    sliderHebrew: true,
    langString: 'ar',
    TOP_PAGE_H2: 'תנועת נוער לצעירים עם ובלי צרכים מיוחדים',
    TOP_PAGE_NUTTON_DONATE: 'לתרומה',
    TOP_PAGE_NUTTON_SIGNUP: 'הרשמה',
    TOP_PAGE_NUMBERS_RIGHT_H2: 'פעילים',
    TOP_PAGE_NUMBERS_LEFT_H2: 'סניפים',
    TOP_PAGE_NUMBERS_RIGHT_H3: 'בתנועת הנוער “כנפיים של קרמבו”',
    TOP_PAGE_NUMBERS_LEFT_H3: 'בפריסה ארצית ועוד מספר רב בתהליך הקמה',
    BIG_VIDEO_H1: 'איל קיציס עושה כנפיים לקרמבו',
    VIDEO_SECTION_H2:
        "'כנפיים של קרמבו' יוצאת בקמפיין גיוס תרומות באמצעות אפליקציית",
    VIDEO_SECTION_PAYBOX: 'PayBox',
    VIDEO_SECTION_P1:
        'דמיינו את עולמכם בלי חברים, האם בכלל אפשרי לדמיין עולם כזה? זאת המציאות שאליה מתעוררים אלפי ילדים כבר כמה שנים!',
    VIDEO_SECTION_P2:
        'למימון פתיחת סניפים עבור כ- 3000 ילדים עם צרכים מיוחדים ומורכבים שנמצאים ברשימות המתנה כדי להצטרף לפעילות חברתית נגישה ומותאמת.',
    MAIN_PAGE_HEADING_PART_1: `כ-3,000 ילדים בעלי צרכים מיוחדים מחכים להצטרף`,
    MAIN_PAGE_HEADING_PART_2: `לכנפיים של קרמבו`,
    values_h1: 'הערכים שלנו',
    value1_h3: 'הובלת שינוי חברתי',
    value1_p:
        '"أجنحة كرمبو" هي حركة شبيبة للشبان مع أو بدون احتياجات خاصة. نعم، نحن حركة شبيبة بكل ما تعنيه الكلمة من معنى ونشطاء الحركة لا يعتبرون نشاطهم "عملا تطوعيا"، بل تجربةً وعملا مجتمعيا – من أجل أنفسهم ومن أجل الآخرين.',
    value2_h3: 'طرح نشاط مجتمعي تربوي',
    value2_p:
        'نشاط مجتمعي – تربوي، غير رسمي، مرة أسبوعيا في ساعات ما بعد الظهر، على شكل إرشاد شخصي – في إطار مجموعة. معظم المرشدين هم شبيبة من التربية العامة. النشاط المشترك يساهم في رفع الوعي لأوساط خاصة والإتاحة المجتمعية. ',
    value3_h3: 'نوفّر مكانا ومعنى لكل شخص',
    value3_p:
        'نحن نعمل إيمانا بأن جميع الأطفال – بدون فروقات في القدرة، الأصل، الدين أو الجنس، لديهم حاجة مشتركة: جميع الأطفال يريدون ويحتاجون للشعور بالانتماء المجتمعي وكل طفل يستحق الاستمتاع بين أصدقائه.',
    value4_h3: 'التزام بإتاحة كاملة',
    value4_p:
        'مكان نشاط متاح، نقل المرشدين من بيتهم إلى مكان النشاط والعودة، في سفريات مخصصة للمعاقين، السفرية مراقبة ويرافقها ناشط في الحركة، في كل نشاط. مساعدة تمريضية، والتي تساعد الأطفال في قضاء حاجاتهم الخاصة، خلال النشاط، في كل واحد من فروع الحركة.',
    vision_header: 'رؤيا وقيَم الحركة',
    create_h2: 'نخلق معًا متسعًا ومعنى لكل شخص',
    create1_h3: 'الرؤيا تعكس روح الحركة وطابعها الأخلاقي',
    create1_p:
        'عمل مشترك على مكان هام، مساهم وذي تأثير من أجل كل واحد من النشطاء، إذا كان ذا احتياجات خاصّة أم لا.',
    create2_h3:
        'النشاط في الحركة يقوده شبيبة، مع أو بدون إعاقات، قادمين من خلفية اجتماعية وثقافية متنوعة.',
    create2_p:
        'نشطاء الحركة هم جيل المستقبل الذي سيصقل وجه المجتمع الإسرائيلي، بروح قيم المساواة الاجتماعيّة، مع الاهتمام والتفكير برفاهية كل المجتمعات المكوّنة للمجتمع الإسرائيلي.',
    create3_h3:
        'المهمّة الملقاة على عاتق الحركة: بناء فرع في كل بلدة ومجتمع في إسرائيل.',
    create3_p:
        'بغية إتاحة المساواة الاجتماعية في الفرص، حياة مجتمع وانتماء مجتمعي لكل طفل ذي احتياجات خاصة – بدون فوارق الثقافة، الوضع الاجتماعي – الاقتصادي، الدين والجنس. بالإضافة، تغيير المفاهيم والمواقف تجاه الأشخاص ذوي الاحتياجات الخاصّة، من قبل الشبان في نفس الجيل ومن قبل المجتمع الإسرائيلي كلّه.',
    circle1_h3: 'أنا صديق – تكافل',
    circle1_p:
        'احترام كل شخص وقدراته. المساعدة، الدعم في القبول والمساهمة باهتمام أحدنا بالآخر. تقبّل حقيقة أن لا أحد منّا متكامل.',
    circle2_h3: '"أنا أحبّ – أحبّ لغيرك ما تحبّ لنفسك"',
    circle2_p:
        'أن نرى الإيجابي ونعمل من دافع الفرح. الحب من دافع الفهم والقدرة على تقبّل كل الحالات بمحبّة، وأيضا الحالات الصعبة. ',
    circle3_h3: 'أنا إسرائيلي',
    circle3_p:
        'أقيمت أجنحة كرمبو في إسرائيل، انعكاسًا للطابع الإسرائيلي المتميّز بالشراكة ومساعدة الآخر. في أجنحة كرمبو هناك شبيبة من جميع ألوان الطيف الاجتماعي في إسرائيل. نحن نقود المجتمع الإسرائيلي نحو تغيير المواقف والمفاهيم تجاه الإعاقات.',
    circle4_h3: 'أنا أنتمي – انتماء، استيعاب، تكافل',
    circle4_p:
        'وظيفتنا أن نتيح ونساعد كل واحد في تحقيق قدرته الكامنة. يجب أن نجيد المساعدة والاستعانة، كل واحد يحقق قدرته الكامنة ويكون شريكا مساهما في العمل.',
    circle5_h3: 'أنا أستطيع – القدرة والاستقلالية',
    circle5_p:
        'إيماني بنفسي، بقدرتي على التأثير وإحداث التغيير ورغبتي في الاختيار واستقلاليّتي.',
    circle6_h3: 'أنا أقود – التزام، مسؤوليّة، قيادة',
    circle6_p:
        'كل واحد منا يمكنه إحداث التغيير، وجميعنا معًا نقود تغييرًا اجتماعيّا. كل واحد منّا هو قائد ويطوّر العمل.',
};
//////////From Press page////////////
exports.press = {
    PRESS_H1: 'من الإعلام',
    PRESS_SIGAL_BTN: 'צור קשר',
    PRESS_HEADER_NAME: 'سيغال ديكل',
    PRESS_HEADER_POSITION: 'مديرة العلاقات العامّة',
    PRESS_HEADER_TEXT_1:
        'عملت خلال عشر سنوات كمالك مشترك ومديرة للعلاقات العامة وعلاقات الزبائن في مجموعة ميتوس (من أكبر شركات التسويق وإنتاج المناسبات التسويقية في إسرائيل).',
    PRESS_HEADER_TEXT_2:
        'عملت في الماضي في مناصب مرتبطة بالعلاقات العامّة وناطقة باسم جمعيات ومكاتب رياديّة مثل "أراد للإعلام"، "سيؤون للإعلام والتسويق – شيرا شكولنيك".',
    PRESS_HEADER_TEXT_3:
        'حاصلة على اللقب الأول في دراسة الإعلام من جامعة تل أبيب، تدير مجال العلاقات العامّة في أجنحة كرمبو منذ يناير 2014. ',
    PRESS_HEADER_CONTACT: 'اتصل بنا',
    PROJECTS_H1: 'مشاريع كرمبوية وتعاون',
    PROJECT1_TITLE: 'סיפור הסניפים דוברי הערבית',
    PROJECT1_TEXT:
        'סיפור פועלם של סניפי "כנפיים של קרמבו" בחברה הערבית, כיצד תורמים לאיחוד הקהילות וחשיבות שילובם בכלל האוכלוסיות בישראל',
    PROJECT2_TITLE: 'אומרים תודה לאיקאה',
    PROJECT2_TEXT:
        'ילדי "כנפיים של קרמבו" מודים לאיקאה על כך שהחברה מאמצת אותם כבר תקופה ארוכה, ובזכותה ניתן להמשיך ולהקים סניפים נוספים',
    PROJECT3_TITLE: 'קליפ המנון',
    PROJECT3_TEXT:
        'המנון תנועת "כנפיים של קרמבו", המשקף את חזון ורוח התנועה. נכתב על ידי נועם חורב ובוצע ע"י ביסאן אבו לבן ושי המבר, ביחד עם חניכי התנועה',
    PROJECT4_TITLE: ' מחנה קיץ מהאגדות - אוגוסט 2015 ',
    PROJECT4_TEXT:
        'מחנה הקיץ של "כנפיים של קרמבו" מעניק ימים של שמחה לפעילים המשתתפים בו ותורם לאחדות הרבה שקיימת בקהילה הקרמבואית',
    PROJECT5_TITLE: ' במסע מיוחד לפולין',
    PROJECT5_TEXT:
        'כתבה ששודרה בערוץ הראשון על מסע פעילי "כנפיים של קרמבו" לפולין. פעילי התנועה לא וויתרו ויצאו למסע כשאר בני גילם - מסע של חיים, בארץ ספוגת מוות',
    PROJECT6_TITLE: 'השיר "שווים" בשפת הסימנים',
    PROJECT6_TEXT:
        'שירם של עילי בוטנר ורן דנקר מבוצע כולו בשפת הסימנים על ידי חונכי "כנפיים של קרמבו" מסניף כוכב יאיר - צור יגאל',
    PROJECT7_TITLE: 'כבוד של אלופים',
    PROJECT7_TEXT:
        'בעזרת כנפיים של קרמבו ובשיתוף פעולה של מנהלת הליגות לכדורגל, זכה יואל סביר בן ה-21 להבקיע את שער הנצחון לשוער הפועל באר שבע בזמן שקהל האוהדים מריע לו ארוכות',
    PROJECT8_TITLE: 'פותחים סניף חדש עם עמוס תמם',
    PROJECT8_TEXT:
        'קמפיין גיוס המונים למען פתיחת סניף "כנפיים של קרמבו" בהשתתפות עמוס תמם. תוך כחודש גוייס סכום של כ-200,000₪',
    PROJECT9_TITLE: 'יום חונכים ארצי',
    PROJECT9_TEXT:
        'הזמר רותם כהן, בשירו "אל העולם שלך", בביצוע מרגש בשפת הסימנים, ביחד עם אלפי פעילי התנועה',
    PAPER_H1: 'من الصحافة',
    PAPER1_TITLE: 'מסדר הכנפיים של הגברת הראשונה.',
    PAPER1_TEXT:
        'صفحات المنتصف – نحاما رفلين، السيدة الأولى تتحدث بتأثّر عن مشاركتها في فعالية "مسدار كنفايم" في فرع القدس.',
    PAPER2_TITLE: 'הפנים היפות של ישראל: כנפיים של קרמבו מגיעה לאו”ם.',
    PAPER2_TEXT:
        '(اليوم العالمي لمساواة حقوق الأشخاص ذوي الإعاقات) عن ماي أوفير، أول طالبة في كرمبو وعن الخطاب الذي قدمته في الأمم المتحدة في إطار بعثة خاصة من "أجنحة كرمبو" والتي تمت دعوتها لطرح بشارة التغيير الاجتماعي الذي تقوم به الحركة في إسرائيل والحديث عن خصائصها لممثلي الدول الأعضاء في الأمم المتحدة، بعث شبيبة ووكالات تهتم بجيل المستقبل.',
    PAPER3_TITLE: '"בשביל בתי זאת הפסגה של הקיץ”.',
    PAPER3_TEXT:
        '(قبل حفل التبرعات) ميخال بعيلن عن "المخيم الصيفي" التابع لكرمبو وعن استضافة الوزير بينيت خلاله. "بدون كرمبو يبدو أننا ما كنت لأتمكن من العيش" – ميخال طالبة من يافنيه تعاني من شلل دماغي.',
    PAPER4_TITLE: 'מנצחים ביחד',
    PAPER4_TEXT:
        'مقال رئيسي في ملحق "شيشبات" عن كومونات تل أبيب التابعة لـ"أجنحة كرمبو"، أول كومونة مدمجة في إسرائيل.',
    PAPER5_TITLE: 'מישהו לעוף איתו',
    PAPER5_TEXT:
        '(إبّان حفل التبرعات) حاجيت رون رابينوبيتش حول افيك سوفير – مرشد من كريات جات يعاني من العمى والشلل الدماغي وعن طالبته روتم الموجودة على سلسلة التوحّد.',
    PAPER6_TITLE: 'משפחה עם כנפיים',
    PAPER6_TEXT:
        '(إبّان حفل التبرعات) حاجيت رون رابينوبيتش حول يهوديت تويتو من صفد – أم بالتبني لعشرات الأطفال وابنهم افيرام طالب في كرمبو أصبح لاحقا مرشدا لطفل موجود على سلسلة التوحّد.',
    PAPER7_TITLE: 'מתקשר רק באמצעות מבע פניו - ומאושר.',
    PAPER7_TEXT:
        '(إبّان حفل التبرعات) إميلي عمروسي حول تمارا، قادمة من جنوب إفريقيا، أم عزباء من يافنيه، وعن ابنها كنيا طالب في كرمبو يعاني من شلل دماغي ويتواصل فقط من خلال تعابير وجهه.',
    PAPER8_TITLE:
        'הצעירה שלימדה את המגזר הערבי והבדואי לעזור לילדים עם מוגבלויות',
    PAPER8_TEXT:
        '(يوم المرأة العالمي) الشابة التي علمت الوسط العربي البدوي – ختام أبو بدر، مؤسسة ومديرة اللواء متعدد الثقافات في كرمبو، فتحت فروعا للحركة في كل أرجاء البلاد وساعدت في رسم البسمة على شفاه أطفال عرب وبدو يعانون من شلل دماغي. ',
    PAPER9_TITLE: '"מגיעים לי חברה, אהבה, צחוק ומשמעות”.',
    PAPER9_TEXT:
        '(مقال تعريفي بالحملة في هدستارت مع عاموس تمام، لصالح تجنيد التبرعات لبناء فرع كرمبو في الرملة) "باز سولتنوفيتش"، في الـ15 من عمرها، طالبة تعاني من شلل دماغي في فرع كريات أونو: "كرمبو غيرت حياتي".',
    PAPER10_TITLE: 'הכניסיני תחת כנפך: הנשים מאחורי התנועה "כנפיים של קרמבו”.',
    PAPER10_TEXT:
        'النساء من وراء حركة الشبيبة "أجنحة كرمبو" – على شرف يوم المرأة العالمي.',
    PAPER11_TITLE: 'الانتصار على التنانين',
    PAPER11_TEXT:
        '(رأس السنة) "الانتصار على التنانين" زيارة نشطاء كرمبو لحضانة أطفال المهاجرين في جنوب تل أبيب. هكذا نتغلب على الآراء المسبقة ونؤلّف بين القلوب.',
    PAPER12_TITLE:
        'כל הדרך לאו"ם: "כנפיים של קרמבו עושה מהפכה חברתית שקטה, אבל עצומה”.',
    PAPER12_TEXT:
        'حقّقت حركة الشبيبة المحلية "أجنحة كرمبو" إنجازا لا نظير له باختيارها مستشارة منظمة الأمم المتحدة في مجال الدمج والاستيعاب ECOSOC.',
    PAPER13_TITLE:
        "התאומים טומי ויאן ברצ'נקו במהדורת חדשות מרכזית ערוץ 10 'שווים' עם מאיה איידן.",
    PAPER13_TEXT:
        '(اليوم العالمي لحقوق الأشخاص ذوي الاحتياجات الخاصة) "متساوون" – مايا آيدن مع التوأم تومي ويان من كرمبو (من الدقيقة 0:53 – بأجزاء حتى نهاية التقرير).',
    PAPER14_TITLE: 'פורשים כנפיים',
    PAPER14_TEXT:
        '(مساء ذكرى الكارثة) مقال عن بعثة كرمبو لرحلة ذاكرة خاصة ومتوفرة إلى بولندا.',
    PAPER15_TITLE: '15 שנים להיווסדות התנועה',
    PAPER16_TITLE: 'גוליבר וקרמבו נפגשים',
    PAPER17_TITLE: 'כנפיים של קרמבו ושל אפל',
    PAPER18_TITLE: 'ניר ברונשטיין באום',
    PAPER19_TITLE: 'תצוגת האופנה',
    MAGAZINE_H1: 'مجلّة كرمبو',
    MAGAZINE1_NAME: 'גיליון מס’ 2',
    MAGAZINE1_DATE: 'ספטמבר 2015',
    MAGAZINE2_NAME: 'גיליון מס’ 3',
    MAGAZINE2_DATE: 'מאי 2016',
    MAGAZINE3_NAME: 'גיליון מס’ 4',
    MAGAZINE3_DATE: 'ינואר 2017',
    MAGAZINE4_NAME: 'מגזין דפוס',
    ACTIVITY_h1: 'אירועי התרמה - קרמבו של קיץ',
    ACTIVITY_PROJECT1_TEXT: 'קרב הדיוות הגדול',
    ACTIVITY_PROJECT2_TEXT: 'קיציס ואירנה חולמים קרמבו',
    ACTIVITY_PROJECT3_TEXT: 'פאודה – גרסת קרמבו',
    ACTIVITY_PROJECT4_TEXT: 'ירון ברלד מחקה את נינט',
    ACTIVITY_PROJECT5_TEXT: 'משיח" וקרמבו של קיץ"',
    ACTIVITY_PROJECT6_TEXT: 'מופע הסטנד אפ של  עדי גולדשמיט',
    view: 'עיין',
    STORY_LINK: 'قناتنا على اليوتيوب',
    isHebrew: true,
    langString: 'ar',
};
exports.reports = {
    REPORT1: 'تقرير مالي 2016',
    REPORT2: 'تقرير كلامي 2016',
    REPORT3: 'تقرير مالي 2015',
    REPORT4: 'تقرير كلامي 2015',
    REPORT5: 'تقرير مستحقّي الأجور 2015',
    REPORT6: 'تقرير مالي 2014 ',
    REPORT7: 'تقرير كلامي 2014',
    REPORT8: 'تقرير مستحقّي الأجور 2014',
    REPORT9: 'تقرير مالي 2013',
    REPORT10: 'تقرير مالي 2013',
    REPORT11: ' تقرير مستحقّي الأجور 2013',
    REPORT12: 'تقارير ماليّة ليوم  31 ديسمبر 2012',
    REPORT13: 'تقرير كلامي 2012',
    REPORT14: ' مستحقّو الأجور – على الشبكة 2012',
    REPORT15: 'عام 2011 تقارير ماليّة ليوم 31',
    REPORT16: 'تقارير ماليّة ليوم 31 ديسمبر (تقرير كلامي) 2011',
    REPORT17: 'قائمة أصحاب أعلى   أجور في الجمعيّة 2011',
    REPORT18: 'تقارير ماليّة ليوم  31 ديسمبر 2010',
    REPORT19: 'تقارير ماليّة ليوم  31 ديسمبر (تقرير كلامي) 2010',
    REPORT20: 'تصريح الخصم الضريبي',
    REPORT21: 'تصريح إدارة الأوراق الماليّة',
    REPORT22: ' شهادة الإدارة السليمة للعام 2019',
    REPORT23: 'مستند 46 حتى ديسمبر 2020',
    REPORT24: ' دستور الجمعيّة',
    REPORT25: 'بوليصة تأمين الحوادث الشخصيّة',
    REPORT26: 'دستور הגרלת "חלום כפול"',
    REPORT27: 'חוזר למחנה קיץ 2019',
    REPORT28: 'טופס ביטול הרשמה למחנה קיץ 2019 וורד',
    REPORTS_H1: 'تقارير ماليّة',
    LANGUAGE: 'arabic',
    ishurim: 'אישורים',
    appendixes: 'נספחים',
    reports: 'reports',
    view: 'עיין',
    ishurFilter: 'אישור',
    takanonFilter: 'دستور',
    takanon: 'תקנון העמותה',
    tisa: 'תקנון הגרלת כרטיסי טיסה',
};
exports.thanks = {
    BTN: 'חזרה לעמוד הבית',
    success: 'הרשמתך נקלטה בהצלחה!',
};
exports.event = {
    form_h1: 'יעד התרומה',
    form_h2: 'מופע התרמה יובל שר 2019',
    form_h3: '*כל ההכנסות קודש לילדי “כנפיים של קרמבו”',
    name: 'שם',
    phone: 'טלפון',
    email: 'מייל',
    id: 'ת”ז/ח”פ',
    id_error: 'אנא הזן ת”ז/ח”פ',
    messgae: 'הודעה',
    send: 'צור קשר',
    managers_h1: 'מטה העמותה',
    name_fill: 'אנא הזן שם ושם משפחה',
    phone_fill: 'אנא הזן מספר טלפון',
    email_fill: 'אנא הזן מייל',
    subject_fill: 'אנא בחר נושא',
    bad_phone: 'שגיאה במספר טלפון',
    bad_email: 'שגיאה בכתובת אימייל',
    send_succeded: 'בקשתך נשלחה',
    newlatter_p:
        'הנני מאשר/ת קבלת דיוור ו/או חומר פרסומי מעמותת “כנפיים של קרמבו”',
    ticket_type: 'סוג כרטיס',
    ticket_500: ' יציע 500 ₪',
    ticket_750: ' אולם 750 ₪',
    ticket_1800: ' חוג הידידים 1800 ₪',
    ticket_amount: 'כמות כרטיסים',
    ticket_total: 'סה”כ ',
    tickets_aside: '*כרטיסים ימתינו לרוכשים בקופה ביום האירוע',
    tickets_submit: 'להמשך תרומה',
    till: 'עד למופע',
    minutes: 'דקות',
    hours: 'שעות',
    days: 'ימים',
};
exports.donate = {
    header: 'בואו נבטיח שלכל הילדים יהיו חברים, בואו ניצור יחד מקום ומשמעות לכל אדם.',
    form_h1: 'זה​ ממש ​קצר ​-​ תתחילו​ כאן:​',
    this_way: 'או​ שאפשר​ גם ​ככה:​',
    first_box_h2: 'להרים טלפון למוקד',
    first_box_p: '077-9555547 או למשרדינו בטלפון 09-8852385',
    second_box_h2: 'לכתוב צ׳ק',
    second_box_h5: 'כתובתנו - רח׳ הנביאים 17 רמה״ש 4727919 ת.ד 1166',
    second_box_p_1: 'לפקודת',
    second_box_p: '“כנפיים של קרמבו” ',
    third_box_h2: 'להעביר לחשבון',
    third_box_h5:
        'בנק הפועלים (12), סניף שאול המלך (532) רח דניאל פריש 3 תל אביב מס חשבון 665538',
    third_box_p: 'העמותה - חשבון ע”ש כנפיים של קרמבו',
    language: 'arabic',
    h1: 'تعالوا لتصبحوا شركائنا',
    text1: 'شكرًا على مساعدتكم في تطوير رؤيا الحركة – خلق متّسع ومعنى لكل شخص، وإتاحتكم لكل طفل أو طفلة ذات احتياجات خاصة الاستمتاع بنشاط اجتماعي وتجربة مثرية في حركة الشبيبة "أجنحة كرمبو". بمساعدتكم سنتمكّن من جعل الأطفال يلامسون الحلم، ومنح عائلاتهم عدّة ساعات من الرّاحة والاستثمار في أطفال العائلة الآخرين، ولمرشدي الحركة – تجربة غنيّة ومجزية. ',
    small_text:
        'يتم تأمين التبرّع – نحن نشدد على اعتماد كل وسائل الأمان المشددة لتأمين تبرّعك.',
    options: 'إمكانيات التبرّع',
    options_text1: 'هاتفيّا على المركز',
    options_text1_1: '077-9555547   أو على مكاتبنا في الهاتف 09-8852385',
    options_text2: 'من خلال شيك لصالح',
    options_text2_1: '"أجنحة كرمبو"',
    options_text2_2: ' شارع هنفيئيم 17 رمات هشارون 4727919 ص.ب 1166',
    options_text4_1: 'حوالة مصرفيّة لحساب الجمعيّة – حساب على اسم أجنحة كرمبو',
    options_text4_2: 'بنك هبوعاليم (12)',
    options_text4_3: 'فرع شاؤول هميلخ (532) شارع دنيال فريش 3 تل أبيب',
    options_text3:
        'التقريب الإيجابي هو مبادرة تتيح لكم القيام بأعمال خيريّة في كل يوم.',
    options_text3_1:
        'انضموا أنتم أيضا إلى التقريب الإيجابي، وكلما قمتم بالشراء من خلال بطاقة ائتمانكم، سيتم تقريب مبلغ الشروة للشاقل الأقرب. الأغورات التي يتم تقريبها سوف يتم التبرع بكاملها لأجنحة كرمبو',
    join: 'انضموا اليوم وابدؤوا التقريب الإيجابي',
    destination: 'وجهة التبرّع',
    destination_1: 'כללי',
    destination_2: 'מסע לאתרי הזיכרון בפולין',
    destination_3: 'מחנה קיץ ',
    destination_4: 'הכשרה והדרכה',
    destination_5: 'אימוץ פעיל- חניך או חונך עם /בלי צרכים מיוחדים',
    destination_6: 'אומנות',
    person_details: 'إيصال على اسم',
    name: 'الاسم الكامل  الشركة',
    phone: 'هاتف',
    address: 'العنوان',
    city: 'المدينة',
    email: 'البريد الإلكتروني',
    id: 'رقم الهويّة  شركة خاصّة',
    notes: 'ملاحظات',
    or: 'או',
    keva: 'خصم مباشر (הוראת קבע)- سريع وسهل!',
    submit: 'המשך לתרומה',
    project: 'وجهة التبرّع',
    name_insert: 'אנא הזן שם ושם משפחה',
    phone_insert: 'אנא הזן מספר טלפון    ',
    address_insert: '   ',
    city_insert: '',
    id_insert: 'שגיאה במספר ח"פ/ת"ז    ',
    email_insert: 'אנא הזן אימייל ',
    insert_total: 'אנא הזן סכום',
    bad_email: 'שגיאה בכתובת אימייל ',
    bad_phone: 'שגיאה במספר טלפון ',
    amount: 'סכום',
    min_amount: 'סכום מינימלי 1 ש"ח',
    chose_project: 'יעד תרומה',
    newlatter_p:
        'הנני מאשר/ת קבלת דיוור ו/או חומר פרסומי מעמותת “כנפיים של קרמבו”',
    round_up_p: 'הנני מעוניין/ת לעגל לטובת עמותת “כנפיים של קרמבו“',
    general: 'כללי',
    error_top: 'אירעה תקלה, תרומתך לא התקבלה.',
    bottom: ' חשבונך לא חוייב',
    try_again: 'נסה שנית',
    sender_email: 'מייל השולח',
    choose_a_blessing: 'אנא בחר/י כרטיס',
    blessing: 'הוסיפו את הברכה האישית שלכם (לא חובה)',
    generalWarningMessage: 'אנא השלם את הפרטים החסרים',
};
exports.branches = {
    h1: 'قائمة الفروع وساعات العمل',
    search: 'חיפוש סניף',
    activity_day: 'יום פעילות',
    working_hours: 'שעות פעילות',
    activity_day_senios: 'יום פעילות חונכים',
    branch_manager: 'מרכז/ת סניף',
    senior_manager: 'רכז/ת בוגר/ת',
    managers_h1: 'المسؤولون – المقرّ الميداني',
    ACTIVE_DAY: 'יום פעילות שכבג',
    ACTIVE_HOURS: 'שעות פעילות שכבג',
};
exports.about = {
    values_h1: 'אודות כנפיים של קרמבו',
    value1_h3: 'הובלת שינוי חברתי',
    value1_p:
        '"أجنحة كرمبو" هي حركة شبيبة للشبان مع أو بدون احتياجات خاصة. نعم، نحن حركة شبيبة بكل ما تعنيه الكلمة من معنى ونشطاء الحركة لا يعتبرون نشاطهم "عملا تطوعيا"، بل تجربةً وعملا مجتمعيا – من أجل أنفسهم ومن أجل الآخرين.',
    value2_h3: 'طرح نشاط مجتمعي تربوي',
    value2_p:
        'نشاط مجتمعي – تربوي، غير رسمي، مرة أسبوعيا في ساعات ما بعد الظهر، على شكل إرشاد شخصي – في إطار مجموعة. معظم المرشدين هم شبيبة من التربية العامة. النشاط المشترك يساهم في رفع الوعي لأوساط خاصة والإتاحة المجتمعية. ',
    value3_h3: 'نوفّر مكانا ومعنى لكل شخص',
    value3_p:
        'نحن نعمل إيمانا بأن جميع الأطفال – بدون فروقات في القدرة، الأصل، الدين أو الجنس، لديهم حاجة مشتركة: جميع الأطفال يريدون ويحتاجون للشعور بالانتماء المجتمعي وكل طفل يستحق الاستمتاع بين أصدقائه.',
    value4_h3: 'التزام بإتاحة كاملة',
    value4_p:
        'مكان نشاط متاح، نقل المرشدين من بيتهم إلى مكان النشاط والعودة، في سفريات مخصصة للمعاقين، السفرية مراقبة ويرافقها ناشط في الحركة، في كل نشاط. مساعدة تمريضية، والتي تساعد الأطفال في قضاء حاجاتهم الخاصة، خلال النشاط، في كل واحد من فروع الحركة.',
    started_h2: 'كيف بدأ كل شيء',
    started_section1_h3: 'בבית משפחת קובי, נולדה "רוח קרמבו"',
    started_section1_p:
        'כנפיים של קרמבו´ הינה תנועת נוער, מובילת שינוי חברתי, הראשונה והיחידה מסוגה בעולם, לילדים ונוער עם ובלי צרכים מיוחדים. בתנועה אלפי פעילים - ילדים ובני נוער, צעירים בשנת שירות וסטודנטים. פעילי התנועה רואים בכנפיים של קרמבו את תנועת הנוער שלהם ואינם מתייחסים לעשייה בה "התנדבות".',
    started_section2_h3: 'מ"רוח קרמבו" ל"כנפיים של קרמבו"',
    started_section2_p:
        '´כנפיים של קרמבו´ מקיימת פעילות חברתית-חינוכית, בלתי פורמאלית, פעם בשבוע בשעות אחה"צ, במודל של חונכות אישית-במסגרת קבוצתית. מרבית החונכים הינם בני נוער מהחינוך הכללי. הפעילות המשותפת תורמת להגברת המודעות לאוכלוסיות מיוחדות ולנגישות חברתית, תוך מתן מענה לצרכיהם הרגשיים והחברתיים והשתלבותם בחברה הישראלית של אנשים עם צרכים מיוחדים.',
    started_section3_h3: 'משק הכנפיים הגיע לכל רחבי הארץ',
    started_section3_p:
        '´כנפיים של קרמבו´ קולטת ילדים רבי נכויות (מגבלות פיזיות/ קוגניטיביות/ מרחביות/ חושיות/ תקשורתיות) ונותנת  מענה לצרכים החברתיים שלהם, במכוונות לפיתוח מיומנויות חברתיות, בינם לבין עצמם, ובינם לבין החונכים שלהם. ',
    started_section3_p_2:
        'הפעולות המועברות בתנועה עוסקות בנושאים שעל סדר יומה של החברה הישראלית והחברה האוניברסאלית ובנוסף מתקיימות פעילויות של תרומה לקהילה במקומות בהם פועלים סניפי התנועה.  ',
    started_section4_p:
        '´כנפיים של קרמבו´ מחויבת להנגשה מלאה של פעילותה: מקום פעילות נגיש, הסעת חניכים מביתם למקום הפעילות וחזרה, בהסעות המותאמות לנכים, ההסעה מפוקחת ומלווה ע"י פעיל של התנועה, בכל פעולה. מטפלת סיעודית, המסייעת בצרכים האינטימיים של הפעילים, במהלך הפעילות, בכל אחד מסניפי התנועה. פעילות מונגשת באמצעות מכשירי תקשורת חלופית, שפת סימנים, סמלי PCS וכד  והנגשה כלכלית באמצעות תשלום דמי הרשמה סמליים בלבד.',
    structure_h1: 'مبنى الحركة',
    milestones_h1: 'ציוני דרך',
    active: 'פעילים',
    branches: 'فروع',
    opened_this_year: 'סניפים שנפתחו בשנה זו',
    managers_h1: 'أعضاء الإدارة',
    contact: 'اتصل بنا',
    vaad: 'اللجنة الإدارية',
    vision_h1: 'رؤيا الحركة',
    vision_h2: 'نخلق معا حيّزًا ومعنى لكل شخص',
    vision_section1_h3: 'الرؤيا تعكس روح الحركة وطابعها الأخلاقي',
    vision_section1_p:
        'بناء شراكة حقيقية، مبادرة وذات تأثير على كل واحد من النشطاء، في حال كان ذي احتياجات خاصة أم لا.',
    vision_section2_h3:
        'يدير النشاطات الحركية أبناء شبيبة، مع أو بدون إعاقات، آتين من خلقية اجتماعية وثقافية متنوعة.',
    vision_section2_p:
        'نشطاء الحركة هم جيل المستقبل الذي سيصقل شخصيّة المجتمع الإسرائيلي، بروح قيم المساواة الاجتماعية، مع الاهتمام والتفكير برفاهية كل الأوساط التي تكوّن المجتمع الإسرائيلي.',
    vision_last_h4:
        'المهمة الواقعة على عاتق الحركة: بناء فرع في كل بلدة ومجتمع في إسرائيل بغية تحقيق مساواة اجتماعية في الفرص، حياة مجتمعية وانتماء مجتمعي.',
    last_h1: 'كلمة المديرة العامة',
    last_p1:
        '"أجنحة كرمبو" تحدث ثورة هادئة، قوية وهامة في المجتمع الإسرائيلي منذ العام 2002.آلاف الأطفال وأبناء الشبيبة مع وبدون احتياجات خاصة، ينشطون في عشرات الفروع في أنحاء البلاد ويشهدون على أن الدمج، الاستيعاب ومساواة الفرص ليست مجرد شعارات بل هي عمل اجتماعي كامل المحتوى، ومساهمة لكل من يعمل فيه.',
    last_p2:
        '"أجنحة كرمبو" تمنح الأطفال المميزين النشاط الاجتماعي الذي ينقصهم في حياتهم وتدمجهم في المجتمع لكي يتمكنوا من تطوير قدراتهم الاجتماعية. مع أبناء شبيبة من التربية العامة، من كل طبقات المجتمع وأوساطه في كل أنحاء البلاد، يصبحون مبادرين اجتماعيين ناشطين من أجل المجتمع، يفتحون فروعا حيث يقومون بدمج الأطفال وأبناء الشبيبة مع أو بدون إعاقات ويغيرون طابع المجتمع الإسرائيلي – إيجابيا.',
    last_p3:
        '"أجنحة كرمبو" هامة بالنسبة لنشطائها، تمنحهم دائرة انتماء اجتماعي وتساعدهم في صقل هويتهم. النشطاء هم سفراء للنوايا الحسنة، ينشرون قيم الحركة في جميع دوائر حياتهم: العائلة، الأصدقاء والمجتمع ويمثلون نموذجا يحتذى به في قبول واستيعاب المختلف.',
    last_p4:
        '"أجنحة كرمبو" هي حركة شبيبة – حركة تتطابق مع كل المركبات الكلاسيكية المرتبطة بالتربية غير الرسمية: المساهمة المجتمعية، الشراكة في اتخاذ القرارات، الإدارة الذاتية، شبيبة من أجل الشبيبة، ثقافة، أيديولوجيا، رموز، زيّ والمزيد.',
    last_p5:
        'نحن نؤمن بأن "أجنحة كرمبو" أثبتت بأنها تستحق شملها بين حركات الشبيبة وبأنها هي من تعمل من أجل حقوق الأطفال والشبيبة ذوي الاحتياجات المعقدة والإعاقات المتعددة – للانتماء للأوساط المساوية لهم، مع ملائمة النشاطات وتوفيرها بكل ما يعنيه ذلك من معنى – بحيث يصبحون جزءا نشطا وقياديا فيها.',
    last_p6:
        'للأسف الشديد، لم يتم الاعتراف بالحركة بعد من قبل وزارة التربية ولا تحصل على التمويل كباقي حركات الشبيبة ونحن نعمل من أجل الحصول على اعتراف رسمي وتمويلي – بحقّ وليس منّةً.',
    last_p7:
        '"أجنحة كرمبو" هي ابتكار إسرائيلي عصريّ وتمت دعوة ممثليها لتمثيل إسرائيل في مؤتمر في الأمم المتحدة (نوفمبر 2015) اعترافا بالنموذج المميز الذي تعرضه كحلّ لقضايا الدمج الجيّد والناجع للأطفال والشبيبة مع أو بدون احتياجات خاصة، في البلاد والعالم.',
    last_p8:
        'أدعوكم للتعرف إلى النشاطات، وأن تكونوا جزءا من العمل الرائع الذي يتمّ في فروع الحركة. تعالوا لتكونوا شركاء في رؤيا "أجنحة كرمبو": نخلق معًا متّسعًا ومعنى لكل شخص والعمل على تحقيق الهدف الفوري – تأسيس فرع في كل بلدة في إسرائيل.',
    last_p9: 'مع الاحترام،',
    last_p10: 'تاليا بجرنو، مدير عام',
    structureBtn: 'לצפיה במבנה התנועה לחצו כאן',
    isHebrew: true,
};
exports.signup = {
    header_h1: 'تسجيل النشطاء',
    header_text_1:
        'تدعوكم حركة "أجنحة كرمبو" للتسجيل في نشاط سنوي، غنيّ ومتنوّع، للمرشدين والطلاب معًا. التكلفة السنويّة للناشط في الحركة رمزيّة، (الناشط الجديد ملزم بشراء القميص الموحّد، الناشط القديم يمكنه شراء قميص إضافيّ، تكلفة القميص 50 شاقلا إضافيًا).',
    header_text_2:
        'تتم جباية الرسوم بالتساوي من جميع النشطاء في الحركة (المرشدين والطلاب سويّة) من منطلق أن جميعهم نشطاء في حركة الشبيبة أجنحة كرمبو بشكلٍ متساوٍ ويستفيدون من النشاط المشترك بالتساوي.',
    header_small:
        '*انتبهوا – رجاء لا تقوموا بتسجيل طلاب جدد (ذوي احتياجات خاصّة) قبل التواصل الأولي مع الفرع، أن يتم التوضيح بوجود مكان، القيام بزيارة تعارف في بيت الطالب والاتفاق على ملائمة مشتركة للطفل في النشاط.',
    header_btn: 'التسجيل كناشط',
    docs_h1: 'מסמכים',
    doc1_text: 'مستند يحتوي على شرح عن التسجيل والنشاط السنوي',
    doc2_text: 'إلغاء رسوم التسجيل للتسجيل السنوي',
    doc3_text: 'مستند إلغاء ورشة  تأهيل',
    doc4_text: 'سياسة الإلغاء',
    doc5_text: 'מפעל אביב לשכבה בוגרת 2019',
    doc6_text: 'טופס ביטול והחזר דמי רישום מפעלי אביב 2019',
    doc8_text: 'טופס ביטול הרשמה למחנה קיץ',
    doc7_text: 'חוזר למחנה קיץ 2019',
    view: 'עיין',
    adopt_h2:
        'إذا أردتم تبنّي ناشط من عائلة فقيرة ومساعدته في تسديد رسوم التسجيل – يتم قبول كل تبرّع بمباركة!',
    adopt_btn: 'لتبنّي ناشط',
};
exports.footer = {
    donate: 'للتبرّع',
    contact: 'اتصل بنا',
    knowladge: 'مركز المعلومات',
    knowladge_1: 'رؤيا وقيَم الحركة',
    knowladge_2: 'حفلات ورموز',
    knowladge_3: 'نشاط الحركة',
    knowladge_4: 'الرؤية التربويّة',
    press: 'من الإعلام',
    press_1: 'مشاريع كرمبوية',
    press_2: 'אירועי התרמה',
    press_3: 'من الصحافة',
    press_4: 'مجلّة كرمبو',
    about: 'حَولنا',
    about_1: 'قيمنا',
    about_2: 'كيف بدأ كل شيء',
    about_3: 'مبنى الحركة',
    about_4: 'ציוני דרך',
    about_5: 'أعضاء الإدارة',
    about_6: 'اللجنة الإدارية',
    about_7: 'رؤيا الحركة',
    about_8: 'كلمة المديرة العامة',
    last_section_1: 'כנפיים של קרמבו',
    last_section_2: '(ע”ר) 580455681',
    last_section_3: 'כתובת',
    last_section_4: ' רחוב הנביאים 17 רמת השרון 4727919',
    last_section_5: 'ת.ד',
    last_section_6: '1166',
    last_section_7: 'דואר אלקטרוני ',
    last_section_8: 'krembo@krembo.org.il',
    last_section_9: 'לפניות ותרומות היכנסו לצור קשר',
    last_section_10: 'מענה קולי 24 שעות ביממה',
    last_section_11: 'משרד',
    last_section_12: '09-8852385',
    last_section_13: '8849*',
};
exports.contact = {
    form_h1: 'اتصل بنا',
    name: 'الاسم',
    phone: 'رقم الهاتف',
    email: 'البريد الإلكتروني',
    subject_select: 'الموضوع',
    subject_1: 'תרומות',
    subject_2: 'تسجيل النشطاء',
    subject_3: 'דרושים',
    subject_4: 'כללי',
    messgae: 'رسالة',
    send: 'اتصل بنا',
    managers_h1: 'مقرّ الجمعيّة',
    name_fill: 'אנא הזן שם ושם משפחה',
    phone_fill: 'אנא הזן מספר טלפון',
    email_fill: 'אנא הזן מייל',
    subject_fill: 'אנא בחר נושא',
    bad_phone: 'שגיאה במספר טלפון',
    bad_email: 'שגיאה בכתובת אימייל',
    send_succeded: 'בקשתך נשלחה',
};
exports.educational = {
    h1: 'الرؤية التربويّة',
    h2: 'אנחנו שואפים לחיבור ושיתוף',
    h3: 'أجنحة كرمبو هي حركة شبيبة تعمل من أجل جمع الشبيبة التي تعاني من إعاقات والربط بينهم وبين الشبيبة ممن لا يعانون من إعاقات، من أبناء جيلهم، من خلال نشاط اجتماعي مشترك. نحن نؤمن بأن بناء أساس للقاءات مشتركة، سيؤدي إلى الفهم المتبادل، ويخلق فرصًا لعلاقات اجتماعية وتغيير المعتقدات والمواقف تجاه الأشخاص الذين يعانون من إعاقات. ',
    section1_h3: 'مفهومنا التربويّ يمكّن المرشدين أيضا',
    section1_p:
        'تذويت مصطلحات: الاستقلالية، القدرة والقيادة بمعناها الواسع والتركيز على النظرة الإيجابية، التي تدعم المعلمين في الحركة أيضا. كأبناء شبيبة يكبرون في مجتمع إنجازاتي، يؤدي الأسلوب التربوي المتّبع في الحركة إلى شعور بالراحة والأمان والذي يتيح التجربة والقيادة.',
    section2_h3: 'مصدر المفهوم التربويّ',
    section2_p:
        'المفهوم التربوي الذي يرتكز عليه نشاط الحركة وضعته السيدة كلاوديا كوبي، أم مؤسسة.',
    section2_p2:
        'مصدر الإلهام الأهم بالنسبة لكلاوديا، كان ابنها كفير، والذي تصفه بالمعلم والقائد والأهم بالنسبة إليها. كفير، الذي لم يحض بالبلوغ، كان طفلا ذا إعاقات معقّدة – لم يتكلم ولم يمشِ، ولكنه تواصل مع محيطه وكان مصرًّا على أن يكون شريكا في حياة عائلته ومحيطه، أن يكون منتمٍ وأن يشارك بكل ما يجري حوله.',
    section3_h3: 'كرامة الإنسان، بدون علاقة لإعاقته أو احتياجاته الخاصّة.',
    section3_p:
        'منطلقنا هو التعامل مع الشخص بنفس المستوى وعدم استخلاص الاستنتاجات من الإعاقة الظاهرة. في المرحلة الأولى، نتعامل مع الشخص حسب عمره وبعدها نلائم الحديث والتواصل معه حسب احتياجاته وقدراته.',
    section4_h3: 'مركبات المفهوم التربويّ',
    section4_p:
        'في أساس مفهومنا التربويّ توجد ثلاثة مركّبات: الاستقلاليّة، القدرة والقيادة. نحن نتعامل مع هذه المصطلحات ليس كتعريفاتها المعجميّة، وبهذه الطريقة، نغيّر التعريفات السائدة في المجتمع.',
    flex_section1_h3: 'القيادة',
    flex_section1_p:
        'نحن نرى في كل شخص القدرة على القيادة. حسب مفهومنا، حاجة الإنسان أيضا – تعتبر قيادة. الشخص الذي يبدي حاجته ويقود وراءه أشخاصا آخرين بغية تحقيق رغبته أو أفكاره، هو شخص قياديّ! حتى لو كان يحتاج للمساعدة بغية إنجاز المهمّة.',
    flex_section2_h3: 'القدرة',
    flex_section2_p:
        'نحن نؤمن بأنه من المهم الإبراز، التقدير والإشادة بأداء وإنجازات الشخص حسب قدراته. إبراز القدرة الموجودة وليس الإعاقة. الاعتراف بالقدرات، حتى لو كانت بسيطة، سيؤدي بنا كمجتمع إلى فهم شامل ومحترِم حيث يتم تقدير الشخص حتى لو كانت قدراته محدودة. نحن نؤمن بأن الدعم الإيجابي وإبراز القدرات، سيؤدي إلى تدعيم ثقة الشخص بنفسه ويؤدي بالتالي إلى نجاحات إضافية.',
    flex_section3_h3: 'استقلاليّة',
    flex_section3_p:
        'يمكن أن تنعكس في التفكير، الرغبة الحرّة، الاختيار، أو أي نشاط صغير. نحن نشجّع تحديد هذه الزوايا لدى كلّ شخص والتي يمكنه من خلالها أن يكون شريكا نشطا في النشاط. وظيفتنا أن نتيح للطالب ذي الإعاقات، أن يكون جزءا من من النشاط من خلال إيجاد نقاط قوته والتشديد عليها.',
    small_bottom:
        'والدا كفير فهما بأن وظيفتهما، واجبهما وحقهما هو توفير الملائمات والوساطة التي يحتاجها، لكي يتيحا له ذلك. ',
    big_bottom:
        'هكذا صقل مفهوم أن الطفل المميز هو محصلة كل مركباته: رغباته، قدراته، تفضيلاته، محيطه والفرص الموجودة في طريقه، ولا ننظر إلى حياته من منطلق "إعاقته" فقط.',
};
exports.activity = {
    h1: 'نشاط الحركة',
    h2: 'ميزة نشاطات الحركة ينبع من ملائمتها للأشخاص الذين يعانون من الإعاقات. ',
    h3: 'نحن نؤمن بأنه من خلال الملائمة والوساطة، يمكن بناء نشاطات اجتماعية حيث يشارك الجميع ويتعلّمون معرفة وقبول بعضهم البعض. لقاءات الحركة تخصّ القيَم المرتبطة بالمجتمع الإسرائيلي، مع التشديد على تغيير المواقف والمفاهيم تجاه الأشخاص الذين يعانون من إعاقات.',
    first_section_part1_h3: 'المرشدون',
    first_section_part1_p:
        'شبيبة ينتمون لجميع أطياف التربية العامة في إسرائيل.',
    first_section_part2_h3: 'طلاب',
    first_section_part2_p:
        'شبان يعانون من إعاقات: جسمانية، ذهنية، حسّية، التواصل والمزيد.',
    second_section_h3:
        'وظيفة المرشدين خلال النشاط هو أن يمثلوا عاملا يلائم النشاط مع احتياجات الطلاب – على المستوى الجسماني، الذهني أو على مستوى التواصل.',
    second_section_p: 'التعارف العميق مع الطلاب ودعم المرشدين',
    flex_part1_h3: 'الحدس',
    flex_part1_p:
        'نحن نشجّع أيضا العلاقة الشخصية والحلول النابعة عن حدس المرشدين خلال النشاط مع الطلاب. من تجربتنا، علاقة جديدة بين شاب لديه بعض السذاجة، ويرتكز على رؤيا إيجابية، سوف يشجع طرح فرص جديدة للطالب.',
    flex_part1_h5: 'קשר אינטואטיבי מעודד הזדמניות חדשות לחניך',
    flex_part2_h3: 'تأهيل',
    flex_part2_p:
        'جميع أصحاب المهام في الحركة يشاركون في التأهيل، والذي يعدّهم للعمل مع الطلاب. التأهيل يتيح متسعا لأسئلة وتساؤلات المرشدين في سياق اللقاء مع الطلاب. نحن نعطي الشرعية لمشاعر المرشدين ونتقبلها ونستوعبها، حتى لو كانت لديهم في البداية خشية من اللقاء بطالب يعاني من إعاقات. نحن ندعمهم ونوضّح بأن هذا الشعور شرعي.',
    flex_part2_h5: 'طرح الأسئلة الصعبة، يؤدي إلى تفهم وقبول الآخر.',
    flex_part3_h3: 'لقاءات تعارف',
    flex_part3_p:
        'نحن نرى أهمية كبيرة في لقاءات التعارف في بيت الطالب، والتي تتيح لنا التعرف عن كثب على الطالب وعائلته. هذه الزيارات تتيح لنا التعرف إلى البيئة الطبيعية المحيطة بالطالب، والحصول على معلومات ومفاهيم حوله ومعلومات عن احتياجاته المختلفة من والديه. لقاءات التعارف تشكّل بداية العلاقة بين الحركة والعائلة.',
    flex_part3_h5: 'הביקורים מאפשרים היכרות מעמיקה על החניך ומשפחתו',
    attitude_h3: 'أسلوب المرشد كوسيط – نموذج إرشاد مميز',
    attitude_p1:
        'هدف الوساطة بين المرشد والطالب هو أن يتيح له وليس "العمل مكانه".',
    attitude_p2:
        'الوسيط هو شخص يتواجد إلى جانب الشخص المحتاج للوساطة. ويوفّر فقط الدعم المطلوب لكي يتيح للطالب المشاركة في النشاط بشكل فعّال.',
    attitude_p3: 'المرشد شريك الطالب في النشاط ويعيش التجربة معه.',
    attitude_p4:
        'يجب على المرشد تحديد المواقف التي عليه فيها التراجع خطوة واحدة إلى الوراء.',
    attitude_p5:
        'اللحظات التي ينجح فيها الطالب الذي يعاني من إعاقة بدون مساعدة ودعم، هي لحظات هامة جدا بالنسبة إليه.',
    attitude_gray:
        'أسلوب المرشد كوسيط، يطبق مبادئ الأسلوب المهني وينعكس بالشكل التالي:',
    last_flex1_h3: 'التشجيع على الاستقلالية',
    last_flex1_p:
        'نحن نشجّع إعطاء فرصة التجربة المستقلة، لهذا نبحث دائما عن الطريقة المناسبة لكل طالب لكي يكون شريكا ومستقلا في النشاط قدر الإمكان. بالإضافة إلى ذلك، نحن نذوّت مصطلح "الوساطة المحدودة" نحن نشجّع المرشدين على الوساطة المحدودة لكي نمنح الطالب استقلاليته. مثلا: يفضل أن تكون نتيجة العمل الإبداعي غير مثاليّة، ولكن أن تكون نتاج عمل مشترك بين الطالب والمرشد، عن كونها عملا مثاليا يجلس خلاله الطالب وينظر فقط.',
    last_flex2_h3: 'الفهم والإصغاء',
    last_flex2_p:
        'الفهم والإصغاء يشكلان جزءا هاما في مسار الإرشاد. من المهم فهم ومعرفة خصائص إعاقة الطالب، قدراته وإعاقاته، أسباب تصرفاته المختلفة، الحالات التي يمكن أن تشكل تحدٍّ بالنسبة إليه واحتياجاته ورغباته الفورية خلال النشاط. ',
    last_flex3_h3: 'كرامة الإنسان',
    last_flex3_p:
        'كل طالب يأتي من خلفية مختلفة، كل طالب لديه قدرات وإعاقات خاصة به، رغبات مختلفة، وكل طالب يتعرض إلى عالم مختلف من الفرص والتجارب. كل هذه الأمور تصقل شخصيته وتؤثر على آراءه وقدراته. لهذا، عندما نتوجه للحديث مع الطالب، يمكن أن نجد اختلافات كبيرة بين شخص وآخر، رغم أنه ينتمي إلى نفس المجموعة. على ضوء هذا، نتوجه إلى كل طالب بشكل طبيعي، عادي ومحترم. وبعد التعرف إليه بعمق، سنعرف مستوى فهمه ونلائم أنفسنا لهذا المستوى.',
    last_flex4_h3: 'نظرة إيجابية',
    last_flex4_p:
        'فحص كل حالة من منطلق الرغبة بإيصال كل طالب لتجربة النجاح، مع تحديد وإبراز نقاط قوته وقدراته وليس الصعوبات.',
    last_flex5_h3: 'الإتاحة والملائمة',
    last_flex5_p:
        ' المرشد يلائم ويتيح النشاط بشكل شخصي، وملائم لطالبه. يمكن أن تنعكس الملائمة في طرق التواصل مع الطالب، في ملائمة نشاطات الإبداع والدعم في نشاطات المجموعة والحركة.',
};
exports.vision = {
    h1: 'رؤيا وقيَم الحركة',
    create_h2: 'نخلق معًا متسعًا ومعنى لكل شخص',
    create1_h3: 'الرؤيا تعكس روح الحركة وطابعها الأخلاقي',
    create1_p:
        'عمل مشترك على مكان هام، مساهم وذي تأثير من أجل كل واحد من النشطاء، إذا كان ذا احتياجات خاصّة أم لا.',
    create2_h3:
        'النشاط في الحركة يقوده شبيبة، مع أو بدون إعاقات، قادمين من خلفية اجتماعية وثقافية متنوعة.',
    create2_p:
        'نشطاء الحركة هم جيل المستقبل الذي سيصقل وجه المجتمع الإسرائيلي، بروح قيم المساواة الاجتماعيّة، مع الاهتمام والتفكير برفاهية كل المجتمعات المكوّنة للمجتمع الإسرائيلي.',
    create3_h3:
        'المهمّة الملقاة على عاتق الحركة: بناء فرع في كل بلدة ومجتمع في إسرائيل.',
    create3_p:
        'بغية إتاحة المساواة الاجتماعية في الفرص، حياة مجتمع وانتماء مجتمعي لكل طفل ذي احتياجات خاصة – بدون فوارق الثقافة، الوضع الاجتماعي – الاقتصادي، الدين والجنس. بالإضافة، تغيير المفاهيم والمواقف تجاه الأشخاص ذوي الاحتياجات الخاصّة، من قبل الشبان في نفس الجيل ومن قبل المجتمع الإسرائيلي كلّه.',
    circle1_h3: 'أنا صديق – تكافل',
    circle1_p:
        'احترام كل شخص وقدراته. المساعدة، الدعم في القبول والمساهمة باهتمام أحدنا بالآخر. تقبّل حقيقة أن لا أحد منّا متكامل.',
    circle2_h3: '"أنا أحبّ – أحبّ لغيرك ما تحبّ لنفسك"',
    circle2_p:
        'أن نرى الإيجابي ونعمل من دافع الفرح. الحب من دافع الفهم والقدرة على تقبّل كل الحالات بمحبّة، وأيضا الحالات الصعبة. ',
    circle3_h3: 'أنا إسرائيلي',
    circle3_p:
        'أقيمت أجنحة كرمبو في إسرائيل، انعكاسًا للطابع الإسرائيلي المتميّز بالشراكة ومساعدة الآخر. في أجنحة كرمبو هناك شبيبة من جميع ألوان الطيف الاجتماعي في إسرائيل. نحن نقود المجتمع الإسرائيلي نحو تغيير المواقف والمفاهيم تجاه الإعاقات.',
    circle4_h3: 'أنا أنتمي – انتماء، استيعاب، تكافل',
    circle4_p:
        'وظيفتنا أن نتيح ونساعد كل واحد في تحقيق قدرته الكامنة. يجب أن نجيد المساعدة والاستعانة، كل واحد يحقق قدرته الكامنة ويكون شريكا مساهما في العمل.',
    circle5_h3: 'أنا أستطيع – القدرة والاستقلالية',
    circle5_p:
        'إيماني بنفسي، بقدرتي على التأثير وإحداث التغيير ورغبتي في الاختيار واستقلاليّتي.',
    circle6_h3: 'أنا أقود – التزام، مسؤوليّة، قيادة',
    circle6_p:
        'كل واحد منا يمكنه إحداث التغيير، وجميعنا معًا نقود تغييرًا اجتماعيّا. كل واحد منّا هو قائد ويطوّر العمل.',
};
exports.symbol = {
    h1: 'حفلات ورموز',
    h2: 'رمز رؤيانا',
    symbol_flex1_h3: 'علم إسرائيل',
    symbol_flex1_p:
        'دولة إسرائيل - المكان الذي انطلقت منه الحركة، والطباع الإسرائيلية في الشراكة ومساعدة الآخرين.',
    symbol_flex2_h3: 'شبل الأسود',
    symbol_flex2_p:
        'يرمز إلى كفير كوبي، الطالب الأول ومصدر إلهام الحركة. رمز رؤيانا يمنح في إطار فروع كرمبو، بعد الانتهاء من برنامج الموروث الذي يشمل نشاطات حول قيَم الحركة.',
    symbol_flex3_h3: 'الأجنحة',
    symbol_flex3_p:
        'هدفنا مدّ الأجنحة وجلب بشائر "التغيير الاجتماعي" للمجتمع الإسرائيلي وللمجتمعات المختلفة في العالم مستقبلًا.',
    symbol_bottom1_h3: 'زيّنا ',
    symbol_bottom1_p:
        'زيّ الحركة يمثّل رمزا أوليّا موحّدا متساوٍ للحركة. طلاب ومرشدو الحركة، يشاركون في الفعاليات بزيّ الحركة، حيث يكون القميص باللون الأزرق وربطة العنق باللون البني – كألوان شعار الحركة. يظهر على ظهر القميص شعار الحركة – من الخلف ومن المقدمة. يتم تصميم الزيّ بحيث يلائم الطلاب، من خلال دمج أزرار خفيّة، حلقة لربطة العنق وأكمام يمكن تقصيرها حسب الحاجة.',
    symbol_bottom1_p2:
        'ربطة العنق الخاصة بالحركة بلون موحّد انطلاقا من قيمة المساواة – جميعنا متساوون، طلابا ومرشدين، جميعنا معًا جزء من الكلّ. ربطة عنق الحركة توزع في حفل الفرع بعد افتتاح السنة بنحو الشهر.خلال الحفل يوقّع المرشدون والطلاب على جملة الرؤيا– نخلق معًا متّسعًا ومعنى لكل إنسان.',
    symbol_bottom2_h3: 'تحيّة الحركة',
    symbol_bottom2_p:
        'كما كل شيء في الحركة، تم اختيار التحيّة انطلاقا من التفكير بجميع نشطاء الحركة، قدراتهم وإعاقاتهم.',
    symbol_bottom2_p2:
        'التحيّة تعكس شعار الحركة، كرمبو وأجنحة. كل واحدة من الأصابع الستّة تمثّل واحدة من قيَم الحركة. يتم تقديم التحيّة خلال مناسبات الحركة مثل: منح رمز الرؤيا، توزيع ربطات عنق الحركة، غناء نشيد "هتكفا" والمزيد.',
};
let dropDown7 = [];
Object.keys(branch_parser_1.branchprices).map(function (key, index) {
    dropDown7.push(key);
});
exports.register = {
    form12Text: [
        'בני/בתי זכאי/ת לגמלת ניידות מהמוסד לביטוח לאומי',
        'בני/בתי זכאי/ת לגמלת ילד נכה מהמוסד לביטוח לאומי',
    ],
    //header
    heading: 'ברוכים הבאים לתנועת “כנפיים של קרמבו”.',
    subheader1:
        'אנו מזמינים אתכם להירשם לפעילות שנתית, עשירה ומגוונת, לחונכים וחניכים כאחד. ',
    subheader2: 'להסבר לגבי דמי ההרשמה והפעילות השנתית יש ללחוץ',
    subheader2Link: 'כאן.',
    subheader3: 'להסבר לגבי ביטול ההרשמה יש ללחוץ',
    subheader3Link: 'כאן.',
    paragraph:
        '*העלות השנתית לפעיל בתנועה הינה סמלית, כאשר כל פעיל חדש מחויב ברכישת חולצת מדים (פעיל ותיק יכול לרכוש חולצה נוספת בעלות של ₪50). התשלום נגבה באופן זהה מכל הפעילים בתנועה, חונכים וחניכים כאחד, מתוך תפיסה שכולם פעילים בתנועת הנוער כנפיים של קרמבו באופן שוויוני וזהה לחלוטין.',
    //
    //nav
    stage1: 'פרטי  חניך',
    stage2: 'אישור הורים',
    stage3: 'סיכום תשלום',
    //
    //forms headers
    firstHeader: 'פרטי חניך',
    secHeader: 'פרטים אישיים',
    //
    //labels
    gender: 'מין',
    dateOfBirth: 'תאריך לידה',
    //
    //placeholders
    form1Placeholders: ['מין', 'חודש', 'יום', 'שנה'],
    form11Placeholders: ['מעוניין בחולצה נוספת?', 'בחר מידת חולצה'],
    form2placeholders: [
        'שם מלא',
        'שם בית ספר',
        'מיקוד',
        'שם משפחה',
        'שכבה',
        'סניף',
        'מס’ תעודת זהות',
        'דוא”ל',
        'ניידות',
        'מספר טלפון',
        'עיר',
        'בעל צרכים מיוחדים',
        'וותק חניך',
        'רחוב ומספר בית',
        'אחוזי נכות',
        'תזונה',
        'קופת חולים',
        'כיתה',
    ],
    //
    tshirtSize: 'בחר מידת חולצה',
    dropDown1: [
        'עצמאי',
        'הליכון',
        'כסא גלגלים',
        'כסא גלגלים ממונע',
        'כסא גלגלים אך יכול ללכת עם עזרה',
        'קושי מוטורי קל',
    ],
    dropDown2: ['חניך חדש(שנה ראשונה)', 'חניך ותיק'],
    dropDown3: ['כן', 'לא'],
    dropDown4: [
        '10',
        '12',
        '14',
        '16',
        'S',
        'M',
        'L',
        'XL',
        'XXL',
        'XXXL',
        'XL4',
    ],
    dropDown5: ['זכר', 'נקבה', 'אחר'],
    dropDown6: ["א'", "ב'", "ג'", "ד'", "ה'", "ו'", "ז'", "ח'", "ט'"],
    dropDown7,
    dropDown8: ['כן', 'לא'],
    firstNameEmpty: 'אנא מלא שם פרטי',
    lastNameEmpty: 'אנא מלא שם משפחה',
    schoolNameEmpty: 'אנא מלא את שם בית הספר',
    streetEmpty: 'אנא מלא כתובת',
    cityEmpty: 'אנא מלא עיר',
    aproveTermsEmpty: 'אנא אשר תקנון התנועה',
    mobillityEmpty: 'אנא בחר מידת ניידות',
    vetekEmpty: 'אנא בחר ותק חניך',
    anotherTshirtEmpty: 'אנא בחר האם הינך מעוניין בחולצה נוספת',
    sizeTshirtEmpty: 'אנא בחר מידת חולצה',
    genderEmpty: 'אנא בחר מגדר',
    classEmpty: 'אנא בחר שכבה',
    classNumberEmpty: 'אנא מלא כיתה',
    branchEmpty: 'אנא בחר סניף',
    specialNeedsEmpty: 'אנא ציין האם החניך בעל צרכים מיוחדים',
    dietEmpty: 'אנא בחר תזונה',
    hmoEmpty: 'אנא בחר קופת חולים',
    monthEmpty: 'אנא הזן חודש',
    dayEmpty: 'אנא הזן יום',
    yearEmpty: 'אנא הזן שנה',
    dayInvalid: 'יום לא תקין',
    yearInvalid: 'שנה לא תקינה',
    emailEmpty: 'אנא מלא כתובת דואר אלקטרוני',
    emailInvalid: 'כתובת דוא"ל לא תקינה',
    idEmpty: 'אנא מלא תעודת זהות',
    idInvalid: 'תעודת זהות אינה תקינה',
    mikudEmpty: 'אנא מלא מיקוד',
    mikudInvalid: 'מיקוד לא תקין',
    phoneEmpty: 'אנא הזן מספר טלפון',
    phoneInvalid: 'מספר טלפון לא תקין',
    btnContinue: 'המשך',
    //form2
    parent1fullNameEmpty: 'אנא מלא שם מלא של הורה החניך',
    parent1placeOfBirthEmpty: 'אנא מלא תאריך לידה של הורה החניך',
    parent1phoneEmpty: 'אנא מלא טלפון ',
    parent1phoneInvalid: 'מספר טלפון לא תקין',
    parent1workPlaceEmpty: 'אנא מלא מקום עבודה',
    parent1emailEmpty: 'אנא הכנס כתובת דוא"ל',
    parent1emailInvalid: 'כתובת דוא"ל לא תקינה',
    parent2phoneInvalid: 'טלפון לא תקין',
    parent2emailInvalid: 'כתובת דוא"ל לא תקינה',
    declarationStatusEmpty: 'אנא סמן תיבה',
    // declarationStatusText1: 'אני מצהיר כי לבני/בתי אין כל מגבלה בריאותית',
    // declarationStatusText2:'יש לבני/בתי מגבלות בריאותיות המונעות השתתפות חלקית בפעילות הנדרשת (כגון: אסטמה, סוכרת נעורים, וכדומה)',
    dropDown9: ['כן', 'לא', 'ללא אלרגיה'],
    disabillityDescriptionEmpty: 'אנא פרט מגבלות',
    kindOfAlergyEmpty: 'אנא פרט את סוג האלרגיה',
    alergyLethalEmpty: 'אנא בחר שדה',
    approvalText:
        '  ידוע לי כי אין באפשרות התנועה לספק את התנאים הדרושים על מנת למנוע חשיפה לאלרגנים/ גורמים מעוררי אפילפסיה ולכל גורם נוסף העלול להוביל ליצירת התקף כלשהו. מחובתי לצייד את בני/בתי בכל הנדרש למתן טיפול רפואי באם ידרש לכך.',
    approvalEmpty: 'אנא אשר הצהרה',
    typesOfDisabillityEmpty: 'אנא סמן לפחות ערך אחד',
    dropDown13: ['רגיל', 'צמחוני', 'טבעוני', 'ללא גלוטן'],
    dropDown10: [
        'ינואר',
        'פברואר',
        'מרץ',
        'אפריל',
        'מאי',
        'יוני',
        'יולי',
        'אוגוסט',
        'ספטמבר',
        'אוקטובר',
        'נובמבר',
        'דצמבר',
    ],
    dropDown14: ['כללית', 'מכבי', 'מאוחדת', 'לאומי', 'אין'],
    //2nd page
    parent1: 'הורה 1',
    parent2: 'הורה 2 (לא חובה):',
    secPageHeading1: 'פרטי הורים',
    secPageHeading3: 'אישור הורים',
    secPageHeading2: 'הצהרת הורים',
    secPageHeading4: 'אישור חשיפה',
    secPageHeading5: 'אישור ליווי נסיעה',
    parentPlaceholders: [
        'שם מלא',
        'ארץ לידה',
        'שנת עליה',
        'מספר טלפון',
        'מקום עבודה',
        'דוא”ל',
    ],
    seizureDropDownPlaceholder: 'תדירות התקפים',
    seizureOccurrenceOptions: [
        'פעם בשנה ויותר',
        'פעם בחצי שנה',
        'פעם בשלושה חודשים',
        'פעם בחודש',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        'שבועי',
        'יומי-מספר התקפים ביום',
    ],
    form3Text: [
        'אני מצהיר כי לבני/בתי אין כל מגבלה בריאותית',
        'יש לבני/בתי מגבלות בריאותיות/רגישויות המונעות השתתפות חלקית בפעילות הנדרשת (כגון: אסטמה, סוכרת נעורים, וכדומה)',
        'פירוט המגבלות הבריאותיות',
        'לבני/בתי יש אלרגיה',
        'לבני/בתי יש אלרגיה מסוג:',
        'אלרגיה מסכנת חיים',
        'לבני/בתי יש קושי בתחומים הבאים (תקשורתית, קוגניטיבית, פיזית, חושית, רגשית, אחר)',
        'סוג הקושי',
        'בני/בתי נעזר/ת בציוד רפואי כגון משאף או ערכת זריקות',
        'פירוט הציוד הרפואי',
        'השימוש נעשה באופן עצמאי',
        'בני/בתי מקבל/ת טיפול תרופתי. ',
        'בני/בתי סובל מאפילפסייה.',
        'פירוט סוגי תרופה ואופן הטיפול בה',
        'מתי קיבל את ההתקף הראשון?',
        'מתי קיבל התקף לאחרונה?',
        'איזה תרופות צורך?',
        'מתי ביקר לאחרונה אצל ניורולוג?',
        'סדר פעולות מומלץ בהתקף',
        'גורמים מעוררי התקף',
        // 'תדירות התקפים',
        'איך נראה התקף?',
        'סימנים מקדימים להתקף',
        `הנני מאשר בזאת כי אין מניעה שבני/בתי ישתתף/תשתתף בפעילות בתנועה למרות הופעת התקפי האפילפסיה.ידוע לי כי במידה ויהיה שינוי בתדירות ובעוצמת ההתקפים של בני / ביתי , או ביכולת הצוות בסניף להתמודד, ייתכן ויהיה צורך בנוכחותי או מבוגר מטעם המשפחה בזמן הפעילות.בחתימתי אני גם מאשר את  הנחייתי שלעיל להתנהלות בעת התקף אפילפסיה של בני / בתי.`,
    ],
    firstSeizureOccurrenceEmpty: 'אנא מלא שדה זה',
    lastSeizureOccurrenceEmpty: 'אנא מלא שדה זה',
    epilepsyDrugsUseEmpty: 'אנא מלא שדה זה',
    lastNeurologistVisitEmpty: 'אנא מלא שדה זה',
    actionSequenceRecommendedEmpty: 'אנא מלא שדה זה',
    seizureCatalistsEmpty: 'אנא מלא שדה זה',
    seizureFrequencyEmpty: 'אנא בחר תדירות',
    howDoesSeizureLookLikeEmpty: 'אנא מלא שדה זה',
    preSeizureSignsEmpty: 'אנא מלא שדה זה',
    seizureTermsApprovalEmpty: 'אנא אשר שדה זה',
    epilepsyNotification: `'כנפיים של קרמבו' תפעל על פי הנחיות ההורה באופן מידי בעת ההתקף, אולם אם ההתקף נמשך מעל 5 דקות, או חוזר על עצמו - יוזעק אמבולנס לסניף, זאת בהתאם להוראות חוזר מנכ"ל משרד החינוך,  תשס"ב/2(א), י"ד תשרי תשס"ב, 1 באוקטובר 2001.לאור האמור לעיל, אנו מבקשים אישורכם לפעילות בנכם / בתכם כדלקמן :`,
    simuLev: '*שימו לב',
    form4Text: [
        'הנני מאשר/ת לבני/בתי להשתתף בפעילות "כנפיים של קרמבו”.',
        `  ידוע לי כי אין באפשרות התנועה לספק את התנאים הדרושים על מנת למנוע חשיפה לאלרגנים/ גורמים מעוררי אפילפסיה ולכל גורם נוסף העלול להוביל ליצירת התקף כלשהו.`,
        `מחובתי לצייד את בני/בתי בכל הנדרש למתן טיפול רפואי בגין מצב רפואי ידוע.`,
    ],
    form5Text: [
        [
            { text: 'לא מאשר כלל', checked: false },
            { text: 'מאשר בתיאום מראש בלבד', checked: false },
            { text: 'מאשר', checked: false },
            { text: 'מאשר למטרות הבאות בלבד: ', checked: false },
        ],
        [
            {
                text: 'שימוש פנימי (במסגרת תצוגה בסניף בלבד - לוח תמונות, מצגות וסרטונים).',
                checked: false,
            },
            { text: 'מצגות- הכשרות, סמינרים, גיוסים.', checked: false },
            {
                text: "רשתות חברתיות (פייסבוק/אינסטגרם/סנפצ'אט).",
                checked: false,
            },
            {
                text: 'לכל מטרה במסגרת חשיפת הפעילות של התנועה בציבור',
                checked: false,
            },
            {
                text: 'תוכן שיווקי - קמפיינים פרסומיים של התנועה (ארצי/עירוני).',
                checked: false,
            },
            {
                text: 'תקשורת - ארצית/מקומית - עיתונות כתובה/טלוויזיה.',
                checked: false,
            },
        ],
        'ידוע לי כי פרטי בני/בתי מועברים לעיתים לרשות מקומית/משרדי ממשלה/חברות ביטוח לצרכי תמיכה וביטוח.',
    ],
    form6Text: [
        "כחלק מנגישותה של התנועה, 'כנפיים של קרמבו' מעמידה מערך היסעים לפעילות השבועית וממנה, שמאפשר לפעילים שאינם עצמאיים וזקוקים לתיווך אישי,להשתתף בפעילות באופן קבוע. את מערך ההיסעים מלווים בני נוער עצמאיים בגילאי 16-18 הפעילים בסניף. מערכי ההיסעים והכשרת מלווי ההסעות מוחזקים ומועברים בסניפים בהנחיית מחלקת בטיחות ומפעלים של התנועה.",
        'ידוע לי כי בני/בתי עשויים לקחת חלק במערך ההיסעים כמלווים של פעילי התנועה הזקוקים להסעה, ליווי הכרוך בנסיעה ברכב ההסעות.',
        'הנני מאשר/ת לבני/בתי להצטרף למערך ההיסעים, אשר הליווי בו מתבצע על ידי בני ובנות נוער הפעילים בסניף.',
        'אני מאשר/ת שקראתי את תקנון התנועה ומקבל/ת כל התנאים הכתובים בו.',
        'שם ההורה המאשר',
        'מס’ ת”ז',
        'דרכי החזרה של בני/בתי מהסניף ביום הפעולה:',
    ],
    //page 2 validations
    // parent1fullNameEmpty: '1',
    // parent1placeOfBirthEmpty: '1',
    // parent1phoneEmpty: '1',
    // parent1workPlaceEmpty: '1',
    // parent1emailEmpty:'1',
    // parent2phoneInvalid:'טלפון לא תקין',
    // parent2emailInvalid: 'כתובת דוא"ל אינה תקינה',
    // declarationStatusEmpty:'אנא מלא הצהרה',
    typeOfAlergyEmpty: 'אנא פרט את סוג האלרגיה',
    typeOfDifficultyEmpty: 'אנא פרט את סוג הקושי',
    medicalEquipmentDescriptionEmpty: 'אנא פרט את הציוד הרפואי',
    parentApprovalEmpty: 'אנא אשר הצהרה',
    parentApproval2Empty: 'אנא אשר הצהרה',
    parentApproval3Empty: 'אנא אשר הצהרה',
    inCaseOfLethalAllergyP:
        'במצב זה, הנך נדרש להמציא הצהרת רופא בנוגע לאלרגיה/רגישות לנוחיותך, מצ״ב פורמט',
    inCaseOfLethalAllergyA: 'לחץ כאן להורדה',
    exposureAprrovalEmpty: 'אנא אשר שדה',
    kindOfExposureEmpty: 'אנא בחר מטרה',
    parentApprovalPublicAuthEmpty: 'אנא אשר שדה',
    lastFormParentAproval1Empty: 'אנא אשר הצהרה',
    lastFormParentAproval2Empty: 'אנא אשר הצהרה',
    lastFormParentAproval3Empty: 'אנא אשר הצהרה',
    approvedParentEmpty: 'אנא הזן את שם ההורה המאשר',
    approvedParentIdEmpty: 'אנא הזן תעודת זהות',
    approvedParentIdInvalid: 'תעודת זהות אינה תקינה',
    wayOfArrivalEmpty: 'אנא בחר דרך החזרה',
    //
    secondFormSubmitBtn: 'המשך לתשלום',
    finishNoPayForm: 'הרשם',
    //third page
    openYear: 'פתיחת שנה',
    addings: 'תוספות',
    summery: 'סיכום תשלום',
    register: 'הרשמה',
    shirt: 'חולצה',
    add: 'הוסף',
    added: 'נוסף',
    remove: 'הסר',
    registerCost: 'עלות ההרשמה',
    shirtCost: 'עלות הזמנת חולצה',
    totalPay: 'סה”כ:',
    payNow: 'שלם עכשיו',
    requestSent:
        'בקשתך נקלטה במערכת. לאחר אישור פנייתך, ישלח אליך מייל לסיום תהליך ההרשמה.',
    CITIES: cities_1.default.map((m) => m.name),
};
exports.workshops = {
    header: 'הרצאות וסדנאות',
    subheader: `"כנפיים של קרמבו"  הינה תנועת נוער רב גונית, בה פעילים ביחד ילדים ונוער עם ובלי מוגבלויות, מכל רבדי החברה הישראלית: חילונים, דתיים, מוסלמים, נוצרים, בדואים, דרוזים, מכל קשת הלקויות ודרגות החומרה.  `,
    mainTextOne: `ב"כנפיים של קרמבו" פותח מודל שילוב והכלה חדשני, המחבר בין ילדים ובני נוער עם צרכים מיוחדים לבין בני נוער מהחינוך הכללי, מכל קצוות החברה. `,
    mainTextTwo: `המודל מאפשר פעילות משותפת, נגישה ומותאמת המביאה לידי ביטוי את היכולות של כל הפעילים. בשל השינוי שפעילות זו מחוללת בחברה הישראלית כלפי אוכלוסיית הצרכים המיוחדים וכלפי אוכלוסיות מודרות בכלל, זכה מודל השילוב הייחודי של התנועה להכרה בין לאומית ע"י האו"ם ו"כנפיים של קרמבו" זכו המעמד של "יועץ מיוחד" בנושא שילוב (יולי 2018). `,
    mainTextThree: `אנו מציעים מגוון של פעילויות, הרצאות וסדנאות, מוכנות מראש או בבנייה והתאמה אישית במגוון נושאים (עולם הצרכים המיוחדים, פעילות משלבת, רוח קרמבו וערכי קרמבו ועוד).`,
    mainTextFour: `באם אתם מעוניינים בהרצאה / סדנה `,
    mainTextFive: `מלאו טופס קצר שנוכל להתאים את ההרצאה או הסדנה לצרכים המדויקים שלכם.`,
    mainTextSix: `אנא הקדישו זמן ומחשבה למילוי הטופס, מלאו את הפרטים בהרחבה והוסיפו בהערות מידע נוסף אם צריך על מנת שנוכל לענות על הצרכים בצורה המיטבית ביותר!`,
    mainTextSeven: `*חוברת ההרצאות והסדנאות מצורפת וניתן לעיין בה.`,
    mainH1: 'טופס לבניית הרצאה/סדנה - כנפיים של קרמבו',
    mainB: 'שלום רב',
    mainP1: '"כנפיים של קרמבו"  הינה תנועת נוער רב גונית, בה פעילים ביחד ילדים ונוער עם ובלי מוגבלויות, מכל רבדי החברה הישראלית: חילונים, דתיים, מוסלמים, נוצרים, בדואים, דרוזים, מכל קשת הלקויות ודרגות החומרה.  ',
    mainP2: `ב"כנפיים של קרמבו" פותח מודל שילוב והכלה חדשני, המחבר בין ילדים ובני נוער עם צרכים מיוחדים לבין בני נוער מהחינוך הכללי, מכל קצוות החברה. המודל מאפשר פעילות משותפת, נגישה ומותאמת המביאה לידי ביטוי את היכולות של כל הפעילים. בשל השינוי שפעילות זו מחוללת בחברה הישראלית כלפי אוכלוסיית הצרכים המיוחדים וכלפי אוכלוסיות מודרות בכלל, זכה מודל השילוב הייחודי של התנועה להכרה בין לאומית ע"י האו"ם ו"כנפיים של קרמבו" זכו המעמד של "יועץ מיוחד" בנושא שילוב (יולי 2018).`,
    mainP3: 'אנו מציעים מגוון של פעילויות, הרצאות וסדנאות, מוכנות מראש או בבנייה והתאמה אישית במגוון נושאים (עולם הצרכים המיוחדים, פעילות משלבת, רוח קרמבו וערכי קרמבו ועוד). נשמח שתמלאו טופס קצר שנוכל להתאים את ההרצאה או הסדנה לצרכים המדויקים שלכם. אנא הקדישו זמן ומחשבה למילוי הטופס, מלאו את הפרטים בהרחבה והוסיפו בהערות מידע נוסף אם צריך על מנת שנוכל לענות על הצרכים בצורה המיטבית ביותר!',
    formH1: 'פרטים ליצירת קשר ומידע על הארגון',
    formH1Span: '(נא למלא את כל הפרטים)',
    formName: 'שם מלא',
    formPhone: 'נייד ליצירת קשר',
    formMail: 'אימייל ליצירת קשר',
    formOrgName: 'שם האירגון הפונה',
    formTextArea: 'נשמח אם תוסיפו כמה מילים על האירגון ופעילותו בכלליות',
    formTextAreaMobile: 'פירוט האירגון ופעילותו הכללית',
    formDate: 'תאריך מבוקש להנחיה*',
    formPlace: 'מקום ההרצאה/ הסדנה/ הביקור:',
    formDisclaimer:
        '*במידה והתאריך אינו ידוע או שמדובר בסדנה של יותר ממפגש אחד השאירו שדה זה ריק',
    sendForm: 'שלח טופס',
    errGeneral: 'שדה חובה',
    errPhone: 'טלפון לא תקין',
    errEmail: 'כתובת מייל לא תקינה',
    headingDetails: 'פרטים על ההרצאה/סדנה/ביקור',
    fillAll: '(נא למלא את כל הפרטים)',
    formFirstRadioHeader: 'מתענינים ב',
    formFirstRadioOption1: 'הרצאה',
    formFirstRadioOption2: 'סדנה (יותר ממפגש אחד)',
    formFirstRadioOption3: 'ביקור מונחה בסניף',
    formFirstRadioElse: 'משהו אחר',
    formGoalsHeader: 'מהי מטרת הפעילות?',
    formGoalsSubHeader:
        'אתגרים שרוצים לפתור, שינוי תפיסה, הרחבת אופקים, שילוב מיטבי, היכרות עם עולם הצרכים המיוחדים ועוד…',
    formDurationHeader: 'פרק זמן המוקצה למפגש',
    intrestedInSubjectsHeader: 'נושאים שיכולים לעניין אותכם',
    intrestedInSubjectsOption1: 'עקרונות ההדרכה המשלבת',
    intrestedInSubjectsOption2: 'תהליכי העצמה',
    intrestedInSubjectsOption3: 'רוח קרמבו וערכי קרמבו',
    intrestedInSubjectsOption4: 'ברוכים הבאים לעולם הצרכים המיוחדים',
    intrestedInSubjectsOption5: 'עיבוד חושי - הקשר לתפקודים יום יומיים',
    howDidYouArrive: 'איך הגעתם אלינו',
    howDidYouArriveOption1: 'דרך האתר',
    howDidYouArriveOption2: 'דרך חברים',
    howDidYouArriveOption3: 'היינו בהרצאה או פעילות משותפת בעבר',
    audienceDetails: 'פרטים על קהל היעד',
    attributesHeader: 'תארו את מאפייני משתתפי הקבוצה',
    attributesDetails: 'מהיכן, גילאים, מוגבליות, תחומי עיסוק, ועוד…',
    practicipatesAmount: 'כמות משתתפים',
    practicipatesRelationsHeader: 'מה היא מידת ההיכרות של הקבוצה',
    practicipatesRelationsDetails:
        'האם הקבוצה נפגשת לראשונה בפעילות, האם הם מכירים ממקום העבודה, נפגשים לעיתים תכופות או עוברים פעילות יחד באופן קבוע',
    practicipatesAdjustmentsHeader: 'האם יש בקהל משתתפים הדורשים התאמות',
    practicipatesAdjustmentsDetails:
        'לקויי ראיה אנשים בעלי נכויות שונות - אם כן - נא לפרט',
    notes: 'הערות נוספות',
};
const managers = [
    {
        ManageImg:
            'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/talya.jpg',
        ManageName: 'طاليا هرئيل',
        Manageposition: 'مدير عام',
        ManageEmail: 'talia@krembo.org.il ',
        ManagePhone: '',
        ManageHiddenText:
            'שירתה כקצינת חינוך בצה"ל (השתחררה בדרגת סגן). בוגרת ומנחת קבוצות במיכא"ל. בוגרת האוניברסיטה העברית, תואר BA ביחסים בינלאומיים ומדעי המדינה (בהצטיינות) בוגרת תואר שני במנהל עסקים, אוניברסיטת תל אביב. מנכ"ל כנפיים של קרמבו מיוני 2016. ',
    },
    // {
    //     ManageImg: 'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/בוזי.png',
    //     ManageName: 'ميراف بوعز (بوزي)',
    //     Manageposition: 'قائمقام المدير العام ونائب المدير العام',
    //     ManageEmail: 'boozy@krembo.org.il',
    //     ManagePhone: '',
    //     ManageHiddenText: 'שירתה כקצינה בחיל אויר (השתחררה בדרגת רב סרן). עבדה בעמותת אור ירוק, באלו"ט ובעמותת עזרה למרפא, בתחומי החינוך ופיתוח משאבים. בעלת תואר ראשון בלימודי מזרח תיכון, שפה וספרות ערבית בוגרת קורסי גישור, הדרכה והנחיית קבוצות. סמנכ"ל פתוח משאבים וקש"ח ממאי 2010.'
    // },
    {
        ManageImg:
            'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/גיל.jpg',
        ManageName: ' גיל דורון',
        Manageposition: 'ראש מטה',
        ManageEmail: 'gil@krembo.org.il',
        ManagePhone: '',
        ManageHiddenText:
            'שירת במודיעין חיל הים. בעל ניסיון רב בפיתוח וניהול מיזמים במגזר השלישי, עבד בקבוצת שכולו טוב, בית אקשטיין, האגודה לסוכרת נעורים.בוגר ממכללת רופין, תואר ראשון (B.A) במדעי ההתנהגות. בוגר תואר שני במנהל עסקים של אוניברסיטת חיפה במסלול של ניהול אלכ"רים. ראש מטה ממאי 2018.  ',
    },
    {
        ManageImg:
            'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/Yaniv_Krembo.jpg',
        ManageName: 'يانيف نوني',
        Manageposition: 'مدير الشؤون الماليّة',
        ManageEmail: 'nuni@krembo.org.il',
        ManagePhone: '',
        ManageHiddenText:
            'שירת בחיל הקשר. ניסיון רב בניהול כספים בארגונים מסחריים וקמעוניים. רואה חשבון החל משנת 2013.  בעל תואר B.A במינהל עסקים, התמחות בחשבונאות המכללה האקדמית קרית אונו. בוגר קורס כלכלן פרקטי . מנהל כספים החל מינואר 2019.',
    },
    {
        ManageImg:
            'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/סתיו.jpeg',
        ManageName: 'ستاف فايتس',
        Manageposition: 'مديرة النشاطات والتطوير',
        ManageEmail: 'stav@krembo.org.il',
        ManagePhone: '',
        ManageHiddenText:
            'בוגרת תואר ראשון בלימודי חינוך ומדינת ישראל באוניברסיטת בן גוריון, בעבר מנהלת מרחב דרום בעמותת איילים ומנהלת כפר הסטודנטים באשלים. מנהלת פעילות ארצית החל מינואר 2015',
    },
    {
        ManageImg:
            'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/הדס.jpg',
        ManageName: 'هداس شتينغر',
        Manageposition: 'مديرة الإرشاد',
        ManageEmail: 'hadass@krembo.org.il',
        ManagePhone: '',
        ManageHiddenText:
            'בוגרת המכינה הקדם-צבאית גליל עליון במעיין ברוך. שירתה בחיל החינוך בחוות השומר במחווה אלון בתפקידי ניהול פיקוד והדרכה וזכתה להצטיינות יתרה על תפקידיה. השתחחרה וחזרה לעבוד ב´כנפיים של קרמבו כרכזת בוגרת סניף  נוף הגליל, מנהלת מחוז צפון , מנהלת מחוז שרון ומאז שנת 2015 כמנהלת מחלקת הדרכה.',
    },
    {
        ManageImg:
            'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/nurit.jpg',
        ManageName: ' نوريت بن آشر',
        Manageposition: 'مديرة مجال الاحتياجات الخاصّة',
        ManageEmail: 'nurit@krembo.org.il',
        ManagePhone: '',
        ManageHiddenText:
            'שירתה כקצינת חינוך בצה"ל (השתחררה בדרגת סגן). בוגרת המכללה האקדמית תל חי. תואר BA בחינוך מיוחד ופסיכולוגיה. בוגרת תעודת הוראה בחינוך מיוחד, אוניברסיטת תל אביב. מנהלת תחום צרכים מיוחדים- מרץ 2015 ',
    },
    {
        ManageImg:
            'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/david.jpg',
        ManageName: 'دافيد كاوفمان',
        Manageposition: 'مدير التشغيل',
        ManageEmail: 'david@krembo.org.il',
        ManagePhone: '',
        ManageHiddenText:
            'שרות בצה"ל במגוון תפקידי פיקוד. בעבר בחברת מארס במגוון תפקידי ניהול רכש ולוגיסטיקה. מנהל תפעול החל מאוגוסט 2017.',
    },
    {
        ManageImg:
            'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/dorlee.jpg',
        ManageName: 'דורלי רוזנשטיין',
        Manageposition: 'מנהלת מחלקת פיתוח מקצועי',
        ManageEmail: 'dorli@krembo.org.il',
        ManagePhone: '',
        ManageHiddenText:
            'בעלת תואר שני בחינוך מיוחד ושילוב טכנולוגיות. בנוסף, במסגרת לימודים קודמים התמחתה ב"חינוך מדריך" , אבחון NDFA ואבחון דידקטי. בעבר, מנהלת קליניקה לאבחון וטיפול NDFA ואבחון דידקטי ומנהלת מסלולי הכשרה מקצועיים למאבחנים ומטפלים. מנהלת פיתוח מקצועי החל ממאי ',
    },
    {
        ManageImg:
            'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/טל.jpg',
        ManageName: 'טל בן אריה מנשס',
        Manageposition: 'מנהלת משאבי אנוש',
        ManageEmail: 'hr@krembo.org.il',
        ManagePhone: '',
        ManageHiddenText:
            'בעלת למעלה מ 13 שנות ניסיון במשאבי אנוש במגזר העסקי. כיהנה כסמנכ"ל משאבי אנוש בחברות : Viber, ePlane  ו - iMesh,, בעלת תואר שני בתרבות ומגדר מאוניברסיטת אמסטרדם ותואר ראשון בתקשורת ומדעי המדינה, מאוניברסיטת תל-אביב. מנהלת משאבי אנוש החל ',
    },
];
const managers_branches = [
    {
        name: 'דוד קאופמן',
        position: 'מנהל תפעול ובטיחות',
        phone: '052-7977850 ',
        email: 'david@krembo.org.il',
    },
    {
        name: '	הדס שטנגר',
        position: 'מנהלת מחלקת הדרכה',
        phone: '054-2175735 ',
        email: 'Hadass@krembo.org.il',
    },
    {
        name: '	סתיו ויץ	',
        position: 'מנהלת מחלקת פיתוח ופעילות ארצית',
        phone: ' 054-2542692 ',
        email: 'stav@krembo.org.il',
    },
    {
        name: 'עדי אליהו',
        position: 'מנהלת תחום שנת שירות והגשמה',
        phone: '	050-6392984 ',
        email: 'adieliyahu@krembo.org.il',
    },
    {
        name: '	עדי אלאלוף',
        position: 'מנהלת פעילות ארצית',
        phone: '052-3418444 ',
        email: 'adia@krembo.org.il',
    },
    {
        name: ' 	אייל גולדמן',
        position: ' 	מנהל מחוז צפון',
        phone: '054-5921252  ',
        email: 'eyalg@krembo.org.il',
    },
    {
        name: 'נוי כוכבה',
        position: 'רכזת שילוב מחוז צפון',
        phone: '052-3226333 ',
        email: 'noykochva@krembo.org.il',
    },
    {
        name: 'עתליה שפר	',
        position: '	מנהלת מחוז שרון',
        phone: '052-8991404',
        email: 'atalya@krembo.org.il',
    },
    {
        name: 'עדי אלוני	',
        position: '	רכזת שילוב מחוז שרון',
        phone: '052-6454225',
        email: 'adi.aloni@krembo.org.il',
    },
    {
        name: 'עידו ברנע',
        position: 'מנהל מחוז מרכז	',
        phone: '054-5400617    ',
        email: 'ido@krembo.org.il   ',
    },
    {
        name: 'אור וינרייך',
        position: 'רכזת שילוב מחוז מרכז',
        phone: '050-2440460',
        email: 'or@krembo.org.il',
    },
    {
        name: 'חוליאן קרסנבלט',
        position: 'רכז עירוני תל אביב- יפו',
        phone: '050-7420989',
        email: 'julian.krembo@gmail.com',
    },
    {
        name: 'שקד בן משה',
        position: 'רכזת שילוב מחוז שפלה',
        phone: '052-5672952 ',
        email: 'shaked@krembo.org.il',
    },
    {
        name: 'לינה נבואני	',
        position: '	מנהל מחוז החברה הערבית',
        phone: '054-6738874 ',
        email: 'lina@krembo.org.il',
    },
    {
        name: '	מג´דולין אבו חוף',
        position: 'רכזת שילוב מחוז החברה הערבית',
        phone: '050-3068330',
        email: 'majdoleen@krembo.org.il',
    },
    {
        name: 'שרה פארן',
        position: 'רכזת שילוב מחוז דרום',
        phone: '058-6518562 ',
        email: 'saraf@krembo.org.il',
    },
    {
        name: 'רועי סבן ',
        position: 'מנהל רכש',
        phone: '0542378020 ',
        email: 'roei@krembo.org.il',
    },
];
const managers_vaad = [
    {
        ManageImg:
            'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/Nir Bronstein.jpg',
        ManageName: 'نير برونشتاين',
        Manageposition: 'رئيس مجلس الإدارة',
        ManageHiddenText:
            'نير ضليع منذ نحو العقد في نشاطات واسعة في مجال المساهمة في المجتمع، مع التركيز على النشاطات مع الأطفال ذوي الاحتياجات الخاصة. في السنوات السبع الأخيرة خدم نير كمدير عام بوعليم للأسواق المالية وكرئيس الشركة الابنة بوعليم سكيوريتيز في الولايات المتحدة، قبل ذلك خدم كرئيس ومدير عام شركة تمير فيشمان لإدارة الاستثمارات. نير يشغل اليوم منصب رئيس إدارة في عدة شركات في السوق الإسرائيلي. نير هو خرّيج مشروع المدراء في لندن بيزنس سكول.',
    },
    {
        ManageImg:
            'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/Hain Shane.JPG',
        ManageName: 'حن شاين',
        Manageposition: 'عضو مجلس الإدارة ورئيس اللجنة المالية',
        ManageHiddenText:
            'يانغ يسرائيل (كوست، فورير، جباي وكسيرر) حن شاين، مدقق حسابات، شريك كبير في شركة ارنست منذ العام 1991. عضو اللجنة الإدارية في الشركة ومسؤول عن مجال العقارات والمؤسسات غير الربحية. صاحب تجربة غنية في إدارة المؤسسات غير الربحية بما فيها جامعة تل أبيب، معهد فايتسمن، بيرح، الأوركسترا الفيلهارمونية، والمزيد. صاحب لقب أول في الاقتصاد والحسابات ولقب ثانٍ في التمويل من جامعة تل أبيب.',
    },
    {
        ManageImg:
            'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/Klaodia Kobi.jpg',
        ManageName: 'كلاوديا كوبي',
        Manageposition: 'أم مؤسسة وعضو مجلس إدارة',
        ManageHiddenText:
            'أم كفير كوبي، المتدرّب True Design منذ العام 1996 وحتى هذا اليوم صاحبة شركة التصميم والتسويق الأولى وملهمة الحركة. رئيسة لجنة التصويب والمسؤولة من قبل اللجنة الإدارية على مجال الاحتياجات الخاصة في الحركة ومطورة أسلوب المدرّب كوسيط. خرّيجة قسم الإعلام المرئي، صاحبة لقب B.Des من كلية الفنون والتصميم في القدس "بتسلئيل".',
    },
    {
        ManageImg:
            'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/User photo icon.svg',
        ManageName: 'آفي نيسان',
        Manageposition: 'عضو مجلس إدارة',
        ManageHiddenText:
            'مدقق حسابات حاصل على اللقب الأول في إدارة الأعمال. آفي يملك مكتب تدقيق الحسابات "آفي نيسان – مدقق حسابات". متزوج ولديه ثلاثة أطفال ويسكن في تل أبيب.',
    },
    {
        ManageImg:
            'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/tal.600.jpg',
        ManageName: 'طال آيزنر',
        Manageposition: 'عضو مجلس إدارة',
        ManageHiddenText:
            'نشيط منذ عدة سنوات في مجال الأطفال ذوي الاحتياجات الخاصة. انضم إلى اللجنة الإدارية في "أجنحة كرمبو" في العام 2008. شغل عدة مناصب في شركات هايتك في مجال منع الخداع والسايبر. يعمل اليوم في شركة تشيك بوينت. عضو الجمعية العامّة "بيت إيزي شابيرا"، خريج جامعة تل أبيب. متزوج ولديه 6 أبناء.',
    },
    {
        ManageImg:
            'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/Ika Abarbanel.jpg',
        ManageName: 'إيكا ابربنيل',
        Manageposition: 'عضو مجلس إدارة',
        ManageHiddenText:
            'خبير في مجال إدارة الدمج. عضو إدارة "تيفع" سابقا، المدير الرئيسي في مجال الدمج ونائب مدير عام بين "تيفع" وشركة "بروكتر آند جامبل". شغل منصب قائمقام مدير عام JV-PGT للموارد البشرية ورئيس مشترك لـ"بيزك" ونائب مدير عام التشغيل وخدمات الزبائن في "بليفون". خدم في الجيش مدة 25 عاما وخرج للتقاعد برتبة عميد. حاصل على اللقب الأول والثاني في العلوم السياسية وخريج كلية الأمن الوطني. ناشط في مجال التطوع وعضو اللجنة الإدارية في بتسلئيل Prize4Life كمؤسس ورئيس "تبنّ محارب".',
    },
    {
        ManageImg:
            'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/Nurit berman.jpg',
        ManageName: 'نوريت برمان',
        Manageposition: 'عضو مجلس إدارة',
        ManageHiddenText:
            'تدير مجموعة موقف تعنى باستراتيجيات الموارد البشرية. تأهيل نوريت برمان المهني هو عاملة اجتماعية.',
    },
    {
        ManageImg:
            'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/Tamir Dagan.jpg',
        ManageName: 'تمير دجان',
        Manageposition: 'عضو مجلس إدارة',
        ManageHiddenText:
            'حاصل على اللقب الأول في الاقتصاد والإحصاء من الجامعة العبرية في القدس وحاصل على اللقب الثاني في إدارة الأعمال من جامعة بن غوريون في بئر السبع.',
    },
];
exports.PERMISSIONS = {
    DISABILITY_H1: 'מגבלות רפואיות',
    DISABILITY_ARR: [
        {
            text: 'אני מצהיר כי לבני/בתי אין כל מגבלה בריאותית',
            value: false,
        },
        {
            text: "לבני/בתי מגבלות בריאותיות / רגישויות הדורשות התייחסות מיוחדת או מונעות השתתפות בחלק מהפעילות (כגון אסטמה, סכרת נעורים וכו')",
            value: true,
        },
    ],
    DISABILITY_PLACEHOLDER: 'פירוט המגבלות הבריאותיות',
    ALERGY_H2: 'לבני/בתי יש אלרגיה',
    ALERGY_PLACEHOLDER: 'לבני/בתי יש אלרגיה מסוג:',
    ALERGY_PLACEHOLDER2:
        "מה גורם להתקף האלרגיה/רגישות (למשל אכילה, מגע, חשיפה לריח וכד') ",
    ALERGY_PLACEHOLDER3: "במה מתבטא ההתקף( למשל קוצר נשימה, גירוד, שיעול וכד')",
    ALERGY_PLACEHOLDER4: 'מהן ההנחיות לטיפול בזמן התקף',
    ALERGY_DOC:
        'במצב זה, הנך נדרש להמציא הצהרת רופא בנוגע לאלרגיה/רגישות לנוחיותך, מצ״ב פורמט',
    DOWNLOAD: 'לחץ כאן להורדה',
    LETHAL: 'אלרגיה מסכנת חיים',
    DIFICULTY: 'לבני/בתי יש לקות בתחומים הבאים',
    DIFFICLTY_ARR_L: [
        'תקשורתית',
        'פיזית',
        'קוגניטיבית',
        'חושית',
        'רגשי/התנהגותי',
    ],
    DIFICULTY_PLACEHOLDER: 'סוג הקושי',
    MEDICAL_EQUIUPMENT: 'בני/בתי נעזר/ת בציוד רפואי כגון משאף או ערכת זריקות',
    MEDICAL_EQUIUPMENT_PLACEHOLDER: 'פירוט הציוד הרפואי',
    MEDICAL_SELF: 'השימוש נעשה באופן עצמאי',
    DRUGS: 'בני/בתי מקבל/ת טיפול תרופתי.',
    DRUGS_PLACEHOLDR: 'פירוט סוגי תרופה ואופן הטיפול בה',
    EPILEPSY: 'בני/בתי סובל מאפילפסיה.',
    EPILEPSY_1: 'מתי קיבל את ההתקף הראשון?',
    EPILEPSY_2: 'מתי קיבל התקף לאחרונה?',
    EPILEPSY_3: 'איזה תרופות צורך?',
    EPILEPSY_4: 'מתי ביקר לאחרונה אצל ניורולוג?',
    EPILEPSY_5: 'סדר פעולות מומלץ בהתקף',
    EPILEPSY_6: 'גורמים מעוררי התקף',
    EPILEPSY_7: 'תדירות התקפים',
    EPILEPSY_7_ARR: [
        'פעם בשנה ויותר',
        'פעם בחצי שנה',
        'פעם בשלושה חודשים',
        'פעם בחודש',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        'שבועי',
        'יומי-מספר התקפים ביום',
    ],
    EPILEPSY_8: 'איך נראה התקף?',
    EPILEPSY_9: 'סימנים מקדימים להתקף',
    EPILEPSY_10: 'תרופת חירום',
    EPILEPSY_11: 'דרך נטילת התרופה',
    EPILEPSY_12: 'טווח זמן עד נטילת התרופה',
    EPILEPSY_LAST_P: '*שימו לב',
    EPILEPSY_LAST_P_2:
        '\'כנפיים של קרמבו\' תפעל על פי הנחיות ההורה באופן מידי בעת ההתקף, אולם אם ההתקף נמשך מעל 5 דקות, או חוזר על עצמו - יוזעק אמבולנס לסניף, זאת בהתאם להוראות חוזר מנכ"ל משרד החינוך, תשס"ב/2(א), י"ד תשרי תשס"ב, 1 באוקטובר 2001.לאור האמור לעיל, אנו מבקשים אישורכם לפעילות בנכם / בתכם כדלקמן :',
    EPILEPSY_LAST_CHECK:
        'הנני מאשר בזאת כי אין מניעה שבני/בתי ישתתף/תשתתף בפעילות בתנועה למרות הופעת התקפי האפילפסיה.ידוע לי כי במידה ויהיה שינוי בתדירות ובעוצמת ההתקפים של בני / ביתי , או ביכולת הצוות בסניף להתמודד, ייתכן ויהיה צורך בנוכחותי או מבוגר מטעם המשפחה בזמן הפעילות.בחתימתי אני גם מאשר את הנחייתי שלעיל להתנהלות בעת התקף אפילפסיה של בני / בתי.        ',
    PARENTS_APPROVAL_H1: 'אישור הורים ',
    PARENTS_APPROVAL1: 'הנני מאשר/ת לבני/בתי להשתתף בפעילות "כנפיים של קרמבו”.',
    PARENTS_APPROVAL1_P_STRONG: 'לידיעתכם,',
    PARENTS_APPROVAL1_P:
        '"כנפיים של קרמבו" מבטחת את פעיליה בביטוח צד ג\', לתשומת ליבכם הביטוח מכסה אך ורק פגיעה הנגרמת במהלך הפעילות בתנועה ועקב פעילות זו.',
    PARENTS_APPROVAL2:
        '  ידוע לי כי אין באפשרות התנועה לספק את התנאים הדרושים על מנת למנוע חשיפה לאלרגנים/ גורמים מעוררי אפילפסיה ולכל גורם נוסף העלול להוביל ליצירת התקף כלשהו.        ',
    PARENTS_APPROVAL3:
        'מחובתי לצייד את בני/בתי בכל הנדרש למתן טיפול רפואי בגין מצב רפואי ידוע.',
    EXPOSURE_H1: 'אישור חשיפה    ',
    EXPOSURE_APPROVAL1_ARR: [
        'לא מאשר כלל',
        'מאשר בתיאום מראש בלבד    ',
        'מאשר',
        'מאשר למטרות מסויימות בלבד',
    ],
    EXPOSURE_APPROVAL1_ARR_SPECIAL: 'מאשר למטרות מסויימות בלבד',
    error_msg: 'שדה חובה',
    EXPOSURE_APPROVAL4_ARR: [
        'שימוש פנימי (במסגרת תצוגה בסניף בלבד - לוח תמונות, מצגות וסרטונים).',
        'מצגות - הכשרות, סמינרים, גיוסים.',
        "רשתות חברתיות (פייסבוק/אינסטגרם/סנפצ'אט). ",
        'לכל מטרה במסגרת חשיפת הפעילות של התנועה בציבור        ',
        'תוכן שיווקי - קמפיינים פרסומיים של התנועה (ארצי/עירוני). ',
        'תקשורת - ארצית/מקומית - עיתונות כתובה/טלוויזיה.',
    ],
    EXPOSURE_APPROVAL5:
        'ידוע לי כי פרטי בני/בתי מועברים לעיתים לרשות מקומית/משרדי ממשלה/חברות ביטוח לצרכי תמיכה וביטוח.    ',
    RIDE_PERMISSION_H1: 'אישור ליווי נסיעה    ',
    RIDE_P: "כחלק מנגישותה של התנועה, 'כנפיים של קרמבו' מעמידה מערך היסעים לפעילות השבועית וממנה, שמאפשר לפעילים שאינם עצמאיים וזקוקים לתיווך אישי,להשתתף בפעילות באופן קבוע. את מערך ההיסעים מלווים בני נוער עצמאיים בגילאי 16-18 הפעילים בסניף. מערכי ההיסעים והכשרת מלווי ההסעות מוחזקים ומועברים בסניפים בהנחיית מחלקת בטיחות ומפעלים של התנועה.",
    RIDE_PERMISSION_OPTIONS: [
        'הגעה עצמאית ',
        'מגיעים לאסוף אותו',
        '(משתנה (לפעמים כך ולפעמים כך',
    ],
    RIDE_PERMISSION1:
        'ידוע לי כי בני/בתי עשויים לקחת חלק במערך ההיסעים כמלווים של פעילי התנועה הזקוקים להסעה, ליווי הכרוך בנסיעה ברכב ההסעות.',
    RIDE_PERMISSION2:
        'הנני מאשר/ת לבני/בתי להצטרף למערך ההיסעים, אשר הליווי בו מתבצע על ידי בני ובנות נוער הפעילים בסניף.',
    RIDE_OPTIONS: ["א'", "ב'", "ג'", "ד'", "ה'", "ו'", "ז'"],
    NEXT: 'המשך לפרטי הורים',
    ERROR_MSG: 'שדה חובה',
    UPLOAD_TEXT:
        'במצב זה, הנך נדרש להמציא הצהרת רופא בנוגע לאלרגיה/רגישות לנוחיותך, מצ״ב פורמט',
    UPLOAD_DOWNLOAD: 'לחץ כאן להורדה',
};
exports.PARENTS = {
    YEARS_ARR,
    DAYS_ARR,
    PARENT1_H1: 'הורה 1',
    NAME: 'שם מלא',
    PHONE: 'מספר טלפון',
    COUNTRY: 'ארץ לידה',
    YEAR: 'שנת עליה',
    EMAIL: 'דוא”ל',
    WORK: 'מקום עבודה',
    PARENT2_H1: 'הורה 2 (לא חובה)',
    SIGN: 'חתימה',
    TAKANON:
        '        הנני מתחייב להודיע לרכז הבוגר הסניפי על כל שינוי או הגבלה זמניים / קבועים שיחולו במצב הבריאותי של בני/בתי לרבות קבלת חיסון ו/או החלמה מנגיף הקורונה.',
    SIGN_NAME: 'שם הורה מאשר',
    TAKANON_TEXT: 'תקנון האתר',
    TAKANON_LINK:
        'https://www.krembo.org.il/static/media/%D7%AA%D7%A7%D7%A0%D7%95%D7%9F%20%D7%94%D7%A2%D7%9E%D7%95%D7%AA%D7%94.219c38a9.pdf',
    WITH_MOUSE: 'צורו חתימה עם העכבר',
    RESET: 'איפוס חתימה',
    NEXT: 'המשך לתשלום',
    ERROR_MSG: 'שדה חובה',
    ID: 'ת״ז הורה מאשר',
    ERROR_SIGN: 'חתימה חסרה',
    TAKANON2: 'אני מאשר/ת שקראתי את',
    TAKANON2_1: 'תקנון התנועה ',
    TAKANON2_2: ' להלן ומקבל/ת כל התנאים הכתובים בו',
    TAKANON2_2_LINK:
        'https://www.krembo.org.il/static/media/%D7%AA%D7%A7%D7%A0%D7%95%D7%9F%20%D7%94%D7%A2%D7%9E%D7%95%D7%AA%D7%94.219c38a9.pdf',
};
exports.PERSONAL = {
    YEARS_ARR,
    DAYS_ARR,
    GRADES_ARR: [
        'א',
        'ב',
        'ג',
        'ד',
        'ה',
        'ו',
        'ז',
        'ח',
        'ט',
        'י',
        'י״א',
        'י״ב',
    ],
    H1: 'ברוכים הבאים לתנועת “כנפיים של קרמבו”.',
    H2: 'הרשמה אישור הורים, הצהרת בריאות ותשלום בכרטיס אשראי, לשנת הפעילות 2019/20.',
    H3: 'להסבר לגבי דמי ההרשמה והפעילות השנתית יש ללחוץ',
    H3_2: 'להסבר לגבי ביטול ההרשמה יש ללחוץ ',
    INFO: 'פרטים אישיים',
    HERE: 'כאן',
    GENDER: 'מין',
    GENDER_ARR: ['זכר', 'נקבה', 'אחר'],
    MALE: 'זכר',
    FEMALE: '',
    MONTH: 'חודש',
    MONTHS_ARR: [
        'ינואר',
        'פברואר',
        'מרץ',
        'אפריל',
        'מאי',
        'יוני',
        'יולי',
        'אוגוסט',
        'ספטמבר',
        'אוקטובר',
        'נובמבר',
        'דצמבר',
    ],
    DAY: 'יום',
    YEAR: 'שנה',
    NAME: 'שם פרטי',
    LAST_NAME: 'שם משפחה',
    SCHOOL: 'שם בית ספר',
    ZIP: 'מיקוד',
    FAMILY: 'שם משפחה',
    SHIHVA: 'שכבה',
    SHIHVA_ARR: [
        "א'",
        "ב'",
        "ג'",
        "ד'",
        "ה'",
        "ו'",
        "ז'",
        "ח'",
        "ט'",
        "י'",
        "יא'",
        "יב'",
    ],
    GRADE: 'כיתה',
    GRADE_ARR: [1, 2, 3, 4, 5, 6],
    BRANCH: 'סניף',
    ID: 'מס’ תעודת זהות',
    VETEK: 'וותק חניך',
    VETEK_ARR: ['פעיל חדש (שנה ראשונה)', 'פעיל ותיק'],
    PHONE: 'מספר טלפון פעיל',
    EMAIL: 'דוא”ל',
    POSITION: 'תפקיד',
    POSITION_ARR: [
        'חונך (פעיל בשכבה ח-יב)',
        "חניך (קב' חונכויות)",
        'פעיל שכבת ז',
        "פעיל שכבה צעירה ד'-ו",
        'חבר צוות מוביל',
        'חבר צוות מנהל',
    ],
    POSITION_RES: 'תחום אחריות',
    LEAD_TEAM_ARR: [
        'מרכז סניף',
        'רכז חונכויות ',
        'רכז שכב"ג',
        'רכז מפעלים',
        'רכז שכב״צ ד-ו',
        'רכב שכב״צ ז-ח',
    ],
    MANAGEMENT_TEAM_ARR: [
        'מדריך',
        'משלב',
        'רכז תקשורת',
        'צוות מפעלים',
        'צוות תקשורת',
    ],
    HMO: 'קופת חולים',
    HMO_ARR: ['כללית', 'מכבי', 'מאוחדת', 'לאומי', 'אין'],
    ADDRESS: 'רחוב ומספר בית',
    FOOD: 'תזונה',
    FOOD_ARR: ['רגיל', 'צמחוני', 'טבעוני'],
    CITY: 'עיר',
    EXTRA_SHIRT: 'מעוניין בחולצה נוספת?',
    EXTRA_SHIRT_ARR: ['לא', 'כן'],
    SHIRT_SIZE: 'בחר מידת חולצה',
    SHIRT_ARR: [
        '10',
        '12',
        '14',
        '16',
        'S',
        'M',
        'L',
        'XL',
        'XXL',
        'XXXL',
        'XL4',
    ],
    SHIRT_ARR_NO_OPTION: [
        '10',
        '12',
        '14',
        '16',
        'S',
        'M',
        'L',
        'XL',
        'XXL',
        'XXXL',
        'XL4',
        '',
    ],
    EXTRA: 'תוספות',
    SPECIAL_NEEDS: 'בעל צרכים מיוחדים',
    SPECIAL_NEEDS_ARR: ['לא', 'כן'],
    MOBILITY: 'ניידות',
    MOBILITY_ARR: [
        'עצמאי',
        'הליכון',
        'כסא גלגלים',
        'כסא גלגלים ממונע',
        'כסא גלגלים אך יכול ללכת עם עזרה',
        'קושי מוטורי קל',
    ],
    MOBILITY_REWARD: 'בני/בתי זכאי/ת לגמלת ניידות מהמוסד לביטוח לאומי',
    MOBILITY_REWARD_ARR: ['לא', 'כן'],
    YES: 'כן',
    NO: 'לא',
    DISABLITY_REWARD: 'בני/בתי זכאי/ת לגמלת ילד נכה מהמוסד לביטוח לאומי',
    DISABLITY_REWARD_ARR: ['לא', 'כן'],
    NEXT: 'המשך',
    PERCENT: 'אחוז גמלה',
    BIRTH: 'תאריך לידה',
    ADD: 'הוסף אח/ות',
    EXTRA_BROTHER: 'אח/ות נוסף/ת',
    REMOVE_BROTHER: 'הסר אח/ות',
    ERROR_MSG: 'שדה חובה',
    VALIDATION_ERROR: 'תעודת זהות אינה תקינה',
    VALIDATION_ERROR_PHONE: 'מספר טלפון לא תקין',
    VALIDATION_ERROR_ZIP: 'מיקוד לא תקין',
    VALIDATION_ERROR_EMAIL: 'כתובת דוא"ל לא תקינה',
};
exports.default = {
    LANGUAGE: exports.LANGUAGE,
    navbar: exports.navbar,
    mainpage: exports.mainpage,
    press: exports.press,
    reports: exports.reports,
    thanks: exports.thanks,
    event: exports.event,
    donate: exports.donate,
    branches: exports.branches,
    about: exports.about,
    signup: exports.signup,
    footer: exports.footer,
    contact: exports.contact,
    educational: exports.educational,
    activity: exports.activity,
    vision: exports.vision,
    symbol: exports.symbol,
    register: exports.register,
    workshops: exports.workshops,
    managers,
    managers_branches,
    managers_vaad,
    PERSONAL: exports.PERSONAL,
    PERMISSIONS: exports.PERMISSIONS,
    PARENTS: exports.PARENTS,
    all_branches: branch_parser_1.branchprices,
};
//# sourceMappingURL=content_arabic.js.map
